export const lang = 
{

  "en": {
    "language": "English",
    "tab": {
      "Recent jobs":"Recent jobs",
      "Home": "Home",
      "My Vacancies": "My Vacancies",
      "Post": "Post",
      "Unlocked Profiles": "Unlocked Profiles",
      "My Profile": "My Profile"
    },
    "Home": {
      "Candidate near me":"Candidate near me",
      "Hey, There": "Hey, There",
      "Hey,": "Hey,",
      "Credits": "Credits",
      "Search by Candidates/categories/Services": "Search by Candidates/Industries/Services",
      "Job Categories": "Professional Title",
      "Show More": "Show More",
      "Show Less": "Show Less",
      "Your Subscription Info": "Your Subscription Info",
      "Upgrade your subscription to fulfil your requirements with our best plans.": "Upgrade your subscription to fulfil your requirements with our best plans.",
      "Upgrade your Subscription": "Upgrade your Subscription",
      "0 %": "0 %",
      "Complete Your Profile": "Complete Your Profile",
      "Your profile is incomplete! Please complete your profile to find the right candidate for your job": "Your profile is incomplete! Please complete your profile to find the right candidate for your job",
      "Login Now": "Login Now",
      "Complete Now": "Complete Now",
      "Unlocked Profiles": "Unlocked Profiles",
      "All Profiles": "All Profiles",
      "Candidates Near Me": "Candidates Near Me",
      "View All": "View All",
      "Recommended Candidates": "Recommended Candidates",
      "Add to a List": "Add to a List",
      "Create New List": "Create New List",
      "Add": "Add",
      "Select Round": "Select Round",
      "Use my Current Location": " Use my Current Location",
      "Recent Locations": "Recent Locations",
      "Within 5 KM Radius": "Within 5 KM Radius",
      "Within 10 KM Radius": "Within 10 KM Radius",
      "Within 50 KM radius": "Within 50 KM radius",
      "Within 100 KM Radius": "Within 100 KM Radius",
      "Notifications": "Notifications",
      "No New Notification Found": "No Notification Found",
      "Delete": "Delete",
      "Read": "Read"
    },
    "BlackCard": {
      "Premium": "Premium",
      "Verified": "Verified",
      "About Me": "About Me",
      "Experience": "Experience",
      "Experience Required": "Experience Required",
      "Employment Type": "Type of employment contract",
      "Available": "Available",
      "Expected Salary": "Expected Salary",
      "Skills": "Skills",
      "Education": "Education",
      "Passout Year": "Passout Year",
      "Licenses": "Licenses",
      "Contact Details Locked": "Contact Details Locked",
      "See Full Details": "See Full Details",
      "Less Than 1 KM Away": "Less Than 1 KM Away",
      "KM Away": "KM Away",
      "Availability for Part Time ": "Availability for Part Time ",
      "You": "You",
      "Match": "Match",
      "Add To A List": "Add To A List",
      "Create New List": "Create New List",
      "Select Vacancy": "Select Vacancy",
      "Add": "Add",
      "Select Round": "Select Round",
      "Hire": "Hire",
      "Please unlock the profile first": "Please unlock the profile first",
      "Please do Login/Sign up": "Please do Login/Sign up",
      "Are you sure to unlock the profile": "Are you sure to unlock the profile",
      "Write your lists": "Write your lists"
    },
    "JobCategoriesdata": {
      "Candidate": "Candidate",
      "Candidates": "Candidates"
    },
    "RecommendedComp": {
      "Verified": "Verified",
      "Available": "Available",
      "Total Experience": "Total Experience",
      "Year": "Year",
      "Years": "Years",
      "Current Location": "Current Location",
      "Miles Away": "Miles Away",
      "Package": "Package",
      "Match": "Match",
      "% Match": "% Match",
      "Last seen": "Last seen",
      "ago": "ago",
      "KM Away": "KM Away"
    },
    "UnlockedProfileComp": {
      "KM": "KM",
      "Match": "Match",
      "Unlocked on": "Unlocked on",
      "Total Experience": "Total Experience",
      "Current Location": "Current Location"
    },
    "Message": {
      "Filters": "Filters",
      "Search by Candidates/Keyword": "Search by Candidates/Keyword",
      "Messages": "Messages",
      "No Messages Found": "No Messages Found",
      "You": "You",
      "jobseeker":"Jobseeker",
      "Today":"Today"
    },
    "SearchEvents": {
      "Subscription Details": "Subscription Details",
      "Looking for": "Looking for",
      "Select Required Skills": "Select Required Skills",
      "Employment Type": "Type of employment contract",
      "Part Time": "Part Time",
      "Full Time": "Full Time",
      "Contract": "Contract",
      "Gender": "Gender",
      "Male": "Male",
      "Female": "Female",
      "Experience": "Experience",
      "Years": "Years",
      "Maximum Distance": "Maximum Distance",
      "Km": "Km",
      "Age": "Age",
      "Salary": "Salary",
      "K": "K",
      "Candidate Type": "Candidate Type",
      "Frees": "Frees",
      "Verified": "Verified",
      "Premium": "Premium",
      "Search Now": "Search Now",
      "Add To A List": "Add To A List",
      "Create New List": "Create New List",
      "Select Vacancy": "Select Vacancy",
      "Free": "Free",
      "Current Plan": "Current Plan",
      "VIP": "VIP"
    },
    "UnlockedPro": {
      "Available": "Available",
      "Unlocked Profiles": "Unlocked Profiles",
      "Search by Candidate Name": "Search by Candidate Name",
      "Filters": "Filters",
      "Verified": "Verified",
      "Available 20 Hrs/week": "Available 20 Hrs/week",
      "Total Experience": "Total Experience",
      "Years": "Years",
      "Current Location": "Current Location",
      "km": "km",
      "Package": "Package",
      "Match": "Match",
      "Unlocked on": "Unlocked on",
      "Add to a List": "Add to a List",
      "Create New List": "Create New List",
      "No Data Found": "No Data Found"
    },
    "CreditHistory": {
      "Per Credit Amount":"Per Credit Amount",
      "Enter No. Credits":"Enter No. Credits",
      "Total Amount":"Total Amount",
      "Credit balance": "Credit balance",
      "Available Credits": "Available Credits",
      "Used Credits": "Used Credits",
      "Total Credits": "Total Credits",
      "Subscription Details": "Subscription Details",
      "Plan": "Plan",
      "Days Left": "Days Left",
      "days Validity": "days Validity",
      "Purchased Date": "Purchased Date",
      "Validity": "Validity",
      "days": "days",
      "Amount": "Amount",
      "Payment Mode": "Payment Mode",
      "Credit History": "Credit History",
      "Recharge Credit": "Recharge Credit",
      "Select no. of Credits": "Select no. of Credits",
      "Credits": "Credits",
      "Pay € 30": "Pay € 30",
      "Premium": "Premium",
      "Credit Balance & History": "Credit Balance & History",
      "Upgrade Plan": "Upgrade Plan",
      "Unlocked By": "Unlocked By",
      "Credit Top-up": "Credit Top-up",
      "End Date":"End Date"
    },
    "PaymentSuccesfull": {
      "Thank you !": "Thank you !",
      "Your Payment was Successfull": "Your Payment was Successfull",
      "Your Transcation ID: 1236589742 & Your plan Renews on 15/04/2021": "Your Transcation ID: 1236589742 & Your plan Renews on 15/04/2021",
      "Post Vacancy": "Post Vacancy",
      "Explore Candidates": "Explore Candidates"
    },
    "Subscription": {
      "Free": "Free",
      "Vip": "Vip",
      "Premium": "Premium",
      "Current Plan": "Current Plan",
      "€ 300/pm": "€ 300/pm",
      "Upgrade to": "Upgrade to",
      "€ 499/pm": "€ 499/pm",
      "Upgrade Now": "Upgrade Now",
      "Credit": "Credit",
      "Payment successful": "Payment successful"
    },
    "RecommBlackCard": {
      "month subscription":"Month Subscription",
      "Select Vacancy": "Select Vacancy",
      "Add to a List": "Add to a List",
      "Create New List": "Create New List",
      "Add": "Add",
      "Select Round": "Select Round",
      "10 %": "10 %",
      "%": "%",
      "Match": "Match",
      "Hire": "Hire"
    },
    "Hiring": {
      "Select Vacancy": "Select Vacancy",
      "Hiring Details": "Hiring Details",
      "Vacancy Details": "Vacancy Details",
      "Job Duration": "Job Duration",
      "Submit": "Submit",
      "Add to a List": "Add to a List",
      "Create New List": "Create New List",
      "Add": "Add"
    },
    "UnlockedProfileBlackScreen": {
      "Add to a List": "Add to a List",
      "Create New List": "Create New List",
      "Add": "Add",
      "Done": "Done",
      "Select Round": "Select Round",
      "Match": "Match",
      "Hire": "Hire"
    },
    "CandidateNearMapScreen": {
      "Less than 1 Miles away": "Less than 1 Miles away",
      "Miles away": "Miles away",
      "10% Match": "10% Match",
      "% Match": "% Match",
      "View Profile": "View Profile",
      "10%": "10%",
      "%": "%"
    },
    "SearchScreen": {
      "Search by candidates title, industry Title":"Search by candidates title, industry Title",
      "Filters": "Filters",
      "Experience Between": "Experience Between",
      "Year": "Year",
      "Within": "Within",
      " mi of Radius": " mi of Radius",
      "Salary Between": "Salary Between",
      "K": "K",
      "No Data Found": "No Data Found",
      "Select Vacancy ": "Select Vacancy ",
      "Select Round": "Select Round",
      "Add to a List": "Add to a List",
      "Create New List": "Create New List",
      "Add": "Add",
      "10 % Add": "10 % Add",
      "%": "%",
      "Match": "Match",
      "Hire": "Hire"
    },
    "EditProfile": {
      "Upload image": "Upload image",
      "Personal Information": "Personal Information",
      "Submit": "Sumbit"
    },
    "HireDetails": {
      "Post Settings":"Post Settings",
      "Hires": "Hires",
      "Time Sheet": "Time Sheet",
      "View Full Profile": "View Full Profile",
      "OnGoing Job": "OnGoing Job",
      "Hours Worked": "Hours Worked",
      "Hours": "Hours",
      "Job Duration": "Job Duration",
      "Hired Date": "Hired Date",
      "Verified": "Verified",
      "All times are in your local your local (PTS)": "All times are in your local your local (PTS)"
    },
    "SuccessfulHire": {
      "Your Hire Request to ramesh has been sent Successfully": "Your Hire Request to ramesh has been sent Successfully",
      "Resume Hiring": "Resume Hiring"
    },
    "ApplicantsDetails": {
      "Filters": "Filters :",
      "Availability for Part Time": "Availability for Part Time",
      "99% ": "99% ",
      "match": "Match",
      "Hire": "Hire"
    },
    "NoDataFound": {
      "Opps ! ": "Opps ! ",
      "No Data Found ": "No Data Found ",
      "Post New Vacancy": "Post New Vacancy"
    },
    "PostNewVacancy": {
      "Enter Address":"Enter Address",
      "Confirm to Reject": "Confirm to Reject",
      "Confirm to Accept": "Confirm to Accept",
      "Select Required Skills": "Select Required Skills",
      "Job Description": "Job Description",
      "Select Required Experience": "Select Required Experience",
      "No Of Vacancies": "No Of Vacancies",
      "Job Duration(In Days)": "Job Duration(In Days)",
      "Enter Compensation Amount": "Enter Compensation Amount",
      "Post Vacancy": "Post Vacancy",
      "Enter Job Title": "Enter Job Title",
      "Company Name (Please Update Your Profile)": "Company Name (Please Update Your Profile)",
      "Select Job Category": "Select Profession type",
      "Job Details": "Job Details",
      "Is this vacancy Urgent ? ": "Is this vacancy Urgent ? ",
      "Is Liscense Requrired ?": "Is Liscense Requrired ?",
      "Employment Details": "Type of employment contract",
      "Compensation Details": "Compensation Details",
      "Company Details": "Company Details",
      "Work Location": "Work Location",
      "Contact Person Name": "Contact Person Name",
      "Contact Number": "Contact Number",
      "Select Highest Degree": "Select Highest Degree",
      "Highest Degree Completion Year": "Highest Degree Completion Year",
      "Maximum Application Required": "Maximum Application Required",
      "Enter Search Radius (In Meters)": "Enter Search Radius (In Kilometer)",
      "Enter Short Description": "Enter Short Description",
      "Qualification Required": "Qualification Required",
      "Post Setting": "Post Setting",
      "Review & Post Vacancy": "Review & Post Vacancy"
    },
    "PostSuccessFulMessage": {
      "Edit Vacancy": "Edit Vacancy",
      "Post SuccessFul": "Post SuccessFul",
      "Vacancy Posted Successfully !": "Vacancy Posted Successfully !",
      "Post Another Vacancy": "Post Another Vacancy"
    },
    "MyProfile": {
      "Update Now":"Update Now",
      "Update":"Update",
      "Welcome to Catzapp": "Welcome to Catzapp",
      "Login": "Login",
      "Log Out": "Log Out",
      "My Profile": "My Profile",
      "Create an Account": "Create an Account",
      "My Subscriptions": "My Subscriptions",
      "My Lists": "My Lists",
      "My Vacancies": "My Vacancies",
      "My Unlocked Candidates": "My Unlocked Candidates",
      "Sub Users": "Sub Users",
      "Settings": "Settings",
      "Language": "Language",
      "Alert/Notifications": "Alert/Notifications",
      "Privacy & Policies": "Privacy & Policies",
      "Contact Support": "Contact Support",
      "Update Profile": "Update Profile",
      "Upload Image": "Upload Image",
      "Personal Information": "Personal Information",
      "Submit": "Submit",
      "Upolad Your Company Image": "Upolad Your Company Image",
      "About Your Company": "About Your Company",
      "Company Location": "Company Location",
      "Company Website": "Company Website",
      "Company Name": "Company Name",
      "Add Your Company": "Add Your Company",
      "Select Company": "Select Company",
      "Email": "Email",
      "Last Name": "Last Name",
      "First Name": "First Name",
      "My List Screen": "My List Screen",
      "Remove": "Remove",
      "Select Language": "Select Language",

    },
    "NoUserFound": {
      "Opps !": "Opps !",
      "No Sub User Found": "No Sub User Found",
      "Create Sub User": "Create Sub User"
    },
    "NewSubUser": {
      "User Details": "User Details",
      "Enter User Name": "Enter User Name",
      "Enter First Name": "Enter First Name",
      "Enter Last Name": "Enter Last Name",
      "Enter Email Address": "Enter Email Address",
      "Enter Mobile Number": "Enter Mobile Number",
      "Enter Password": "Enter Password",
      "Confirm Password": "Confirm Password",
      "Update Sub User ": "Update Sub User ",
      "Create Sub User ": "Create Sub User ",
      "Enter Full Name": "Enter Full Name"
    },
    "MyList": {
      "No Data Found": "No Data Found",
      "Remove": "Remove",
      "Available": "Available"
    },
    "Settings": {
      "Email Notification": "Email Notification",
      "Notification": "Notification",
      "Update Password": "Update Password"
    },
    "PrivacyPolicies": {
      "PRIVACY POLICY": "PRIVACY POLICY",
      "Welcome to Recruiter": "Welcome to Recruiter",
      "1. Introduction": "1. Introduction",
      "2. Definitions": "2. Definitions",
      "3. Information Collection and Use": "3. Information Collection and Use",
      "4. Types of Data Collected ": "4. Types of Data Collected ",
      "5. Types of Data Collected": "5. Types of Data Collected"
    },
    "ContactSupport": {
      "Submit": "Submit"
    },
    "MyListsScreen": {
      "Salery- Compensation":"Salery- Compensation",
      "Required": "Required",
      "Immediately": "Immediately",
      "Total Experience": "Total Experience",
      "Years": "Years",
      "Year": "Year",
      "Work Location": "Work Location",
      "Package": "Package"
    },
    "PlayListBlackCard": {
      "Select Vacancy": "Select Vacancy",
      "Select Round": "Select Round",
      "Add to a List ": "Add to a List ",
      "Create New List ": "Create New List ",
      "Add": "Add ",
      "Done": "Done",
      "Match": "Match",
      "Add Your List": "Add Your List"
    },
    "SignUp": {
      "Enter Your Name": "Enter Your Name",
      "Enter Your Phone Number": "Enter Your Phone Number",
      "Enter Your Email": "Enter Your Email",
      "Enter Password": "Enter Password",
      "Set a password": "Set a password",
      "Confirm password ": "Confirm password ",
      "Confirm": "Confirm"
    },
    "LoginPassword": {
      "Login": "Login",
      "Forgot Password": "Forgot Password",
      "Don't have an account?": "Don't have an account?",
      "SignUp": "SignUp",
      "SKIP": "SKIP",
      "Please Enter MobileNumber & Password": "Please Enter MobileNumber & Password",
      "Please Enter Your Mobile Number": "Please Enter Your Mobile Number",
      "Please Enter Your Password": "Please Enter Your Password",
      "Please Enter Valid Password": "Please Enter Valid Password",
      "Please enter your mobile number to complete the login process.": "Please enter your mobile number to complete the login process.",
      "Enter Your Mobile Number": "Enter Your Mobile Number",
      "Enter Your Password": "Enter Your Password",
      "OTP": "OTP",
      "Login to Catzapp Recruiter": "Login to Catzapp Recruiter"
    },
    "ChangePassword": {
      "Please Enter Your New Password & Confirm Password": "Please Enter Your New Password & Confirm Password",
      "Please Enter Your New Password": "Please Enter Your New Password",
      "Please Enter Valid password": "Please Enter Valid password",
      "Please Enter Confirm Password": "Please Enter Confirm Password",
      "Password dosen't Match": "Password dosen't Match",
      "Reset Your Password": "Reset Your Password",
      "Set a password": "Set a password",
      "Confirm password": "Confirm password",
      "Enter Your New password": "Enter Your New password",
      "Confirm Your New password": "Confirm Your New password"
    },
    "ResetPassword": {
      "Please Enter Mobile Number": "Please Enter Mobile Number",
      "Submit OTP": "Submit OTP",
      "Please Enter Otp": "Please Enter Otp",
      "We Have sent One Time Password to": "We Have sent One Time Password to"
    },
    "interOtp": {
      "we have sent an OTP to": "we have sent an OTP to",
      "Did Not Receive Code Yet?": "Did Not Receive Code Yet?",
      "Resend OTP": "Resend OTP",
      "Please Enter OTP": "Please Enter OTP",
      "Submit": "Submit"
    },
    "forgetPassword": {
      "Send OTP": "Send OTP",
      "Get Password": "Get Password",
      "Enter Mobile Number": "Enter Mobile Number",
      "Please enter your mobile number to generate OTP": "Please enter your mobile number to generate OTP",
      "Please Enter Your Mobile Number": "Please Enter Your Mobile Number"
    },
    "myVacancy": {
      "Search by Job Title": "Search by Job Title",
      "My Vacancies": "My Vacancies",
      "No Data Found": "No Data Found",
      "Applications": "Applications",
      "Application": "Application",
      "Edit": "Edit",
      "Delete": "Delete",
      "Required": "Required",
      "Immediately": "Immediately",
      "Posted": "Posted",
      "ago": "ago",
      "Applicants": "Applicants",
      "Hire": "Hire",
      "Apply Filters": "Apply Filters",
      "Clear All": "Clear All",
      "Make Admin":"Make Admin"
    },
    "new": {
      "No Required Immediately":"No Required Immediately",
      "Please Select date range":"Please Select date range",
      "About Company": "About Company",
      "Latter": "Latter",
      "All": "All",
      "Not Premium": "Not Premium",
      "Premium": "Premium",
      "Buy Credit to Unlock the Candidates and Proceed further with the process to send messages, chat or call.": "Buy Credit to Unlock the Candidates and Proceed further with the process to send messages, chat or call.",
      "Are you sure you want to delete this chat?": "Are you sure you want to delete this chat?",
      "Recommended Profiles": "Recommended Profiles",
      "Map View": "Map View",
      "List View": "List View",
      "Read": "Read",
      "2 Credits will get deducted. Are you sure to unlock the profile?": "2 Credits will get deducted. Are you sure to unlock the profile?",
      "Subscribe Now": "Subscribe Now",
      "Please unlock profile first": "Please unlock profile first",
      "You do not have a login yet, Please do login/Signup to continue.": "You do not have a login yet, Please do login/Signup to continue.",
      "Signup/Login": "Signup/Login",
      "Welcome to Catzapp": "Welcome to Catzapp",
      "Create Account": "Create Account",
      "Or": "Or",
      "Sign In": "Sign In",
      "Skip": "Skip",
      "Yes": "Yes",
      "No": "No",
      "Part Time": "Part Time",
      "Full Time": "Full Time",
      "Contract": "Contract",
      "Daily": "Daily",
      "Weekly": "Weekly",
      "Monthly": "Monthly",
      "Yearly": "Yearly",
      "Please Enter Category Name":"Please Enter Category Name",
      "Upload Category Image": "Upload Profession Image",
      "From Date": "From Date",
      "To Date": "To Date",
      "Selected": "Selected",
      "Rejected": "Rejected",
      "First Round": "First Round",
      "Second Round": "Second Round",
      "Type Message": "Type Message",
      "Subject": "Subject",
      "Enter your Description": "Enter your Description",
      "Please Unlock Profile First": "Please Unlock Profile First",
      "Please Select Vacancy": "Please Select Vacancy",
      "Please Select From Date": "Please Select From Date",
      "Please Select To Date": "Please Select To Date",
      "Please Enter Details": "Please Enter Details",
      "Please Enter valid Email": "Please Enter valid Email",
      "Passwords should be a minimum of eight characters in length": "Passwords should be a minimum of eight characters in length",
      "Please Confirm Your Password": "Please Confirm Your Password",
      "Password Does Not Match": "Password Does Not Match"
    },
    "FinalFinal": {
      "You have created a hire request": "You have created a hire request",
      "Hire request already exists": "Hire request already exists",
      "Please Upload Image to add new categories": "Please Upload Image to add new profession",
      "Want to post vacancy please upgrade subscrption": "Want to post vacancy please upgrade subscription",
      "Please enter number of vacancy": "Please enter number of vacancy",
      "Please enter search radius": "Please enter search radius",
      "Enter Your Email Address": "Enter Your Email Address",
      "Enter Your Phone Number": "Enter Your Phone Number",
      "Please Enter Title": "Please Enter Title",
      "Please Enter Description": "Please Enter Description",
      "Enter Your First Name": "Enter Your First Name",
      "Enter Your Last Name": "Enter Your Last Name",
      "Password must be minimum of 8 character": "Password must be minimum of 8 character",
      "Enter Confirm Password": "Enter Confirm Password",
      "Enter Valid Password (password must be combination of letters, numbers and special character": "Enter Valid Password (password must be combination of letters, numbers and special character",
      "Please Enter First Name": "Please Enter First Name",
      "Please Enter Last Name": "Please Enter Last Name",
      "Please Enter Email": "Please Enter Email",
      "Please Select or Add a Company": "Please Select or Add a Company",
      "Please Select Profile Picture": "Please Select Profile Picture",

      "Please enter Job Title": "Please enter Job Title",
      "Please select Company": "Please select Company",
      "Please Select Company Image": "Please Select Company Image",
      "Please Enter Company Detail": "Please Enter Company Detail",
      "Please select Job Category": "Please select Profession type",
      "Please select required Experience": "Please select required Experience",
      "Please enter Job Description": "Please enter Job Description",
      "Please enter short description": "Please enter short description",
      "Please select Skills": "Please select Skills",
      "Please select urgent vacancy": "Please select urgent vacancy",
      "Please select liscense required": "Please select liscense required",
      "Please select to date": "Please select to date",
      "Please select from date": "Please select from date",
      "Please enter maximum number of application": "Please enter maximum number of application",
      "Please select category image": "Please select Profession image",
      "Please select Highest Degree": "Please select Highest Degree",
      "Please enter contact person number": "Please enter contact person number",
      "Please enter contact person name": "Please enter contact person name",
      "Please enter Job Location": "Please enter Job Location",
      "Please enter Compensation Amount": "Please enter Compensation Amount",
      "Please enter Compensation Details": "Please enter Compensation Details",
      "Please enter Job Duration": "Please enter Job Duration",
      "Please select employment details": "Please select Type of employment contract",
      ".png Images are not supported": ".png Images are not supported",
      "Please Enter Company Name": "Please Enter Company Name",
      "Please Enter Company Website": "Please Enter Company Website",
      "OK": "OK"
    },
    "LastL": {
      "Stored Messages": "Stored Messages",
      "Unlocked By": "Unlocked By",
      "User Type": "User Type",
      "Search": "Search",
      "Filter By": "Filter By",
      "Sort By": "Sort By",
      "Experience": "Experience",
      "Location Radius": "Location Radius",
      "Matching Percentage": "Matching Percentage",
      "Package Range": "Package Range",
      "Passout Year": "Passout Year",
      "Distance": "Distance",
      "Search by Area/Street/City Name": "Search by Area/Street/City Name",
      "Please select Highest Degree completion year": "Please select Highest Degree completion year"

    },
    "Lastest": {
      "NoAccount": "Don't have an account?",
      "Login": "Login",
      "Sec": "Sec",
      "Please Wait": "Please Wait",
      "UpGradePlan": "If you want to see candidate profile, please upgrade your plan",
      "Monthly": "Monthly",
      "ProfileUpdate": "Profile Update Successfully",
      "NewCategory": "Add New Profession",
      "Submit": "Submit",
      "Unlocked": "Unlocked",
      "First Round": "First Round",
      "Second Round": "Second Round",
      "Selected": "Selected",
      "Rejected": "Rejected",
      "CandidateAlreadyExist": "Candidate already exist in this list",
      "Monday": "Monday",
      "Tuesday": "Tuesday",
      "Wednesday": "Wednesday",
      "Thursday": "Thursday",
      "Friday": "Friday",
      "Saturday": "Saturday",
      "Sunday": "Sunday",
      "LanguageAlert": "Please Close the application and re-start it again to change the application",
      "Hire": "Hire",
      "Hirerequest": "You have created a Hire request",
      "DeleteJob": "Are You sure want to delete this job?",
      "Address": "Address",
      "Jobs": "Job(s)",
      "Login Successfully": "Login Successfully",
      "Hours": "Hours",
      "Premium": "Premium",
      "Minutes": "Minutes",
      "Invalid credentials": "Invalid credentials",
      "Status : Accepted": "Status : Accepted",
      "Status : Rejected": "Status : Rejected",
      "Unread": "Unread"
    },
    "Newtranslation": {
      "FREE":"FREE",
      "My Subcription":"My Subcription",
      "job": "View Jobs",
      "HireRequest": "View Hire Request",
      "Timesheet": "View Timesheet",
      "Message": "View Message",
      "Unlocked by recruiter": "View Unlocked by recruiter",
      "Monthly Plan": "Monthly Plan",
      "Half Yearly Plan": "Half Yearly Plan",
      "Yearly Plan": "Yearly Plan",
      "valid for ": "valid for ",
      "days": "days",
      "Feature": "Feature",
      "Includescredits": "Includes 10 credits per month.",
      "Credits can be carried forward each month": "Credits can be carried forward each month",
      "Upgrade Subcription": "Upgrade Subcription",
      "Newcandidate": "A New candidate applied to your job driver. check now",
      "No relevant candidate found": "No relevant candidate found",
      "Years of": "Years of",
      "Candidates": "Candidates",
      "The payment has been canceled": "The payment has been canceled",
      "Applicant already exist": "Applicant already exist",
      "The payment method was setup successfully": "The payment method was setup successfully",
      "Your Hire Request has been sent successfully": "Your Hire Request has been sent successfully",
      "Slot Available": "Slot Available",
      "Task Description": "Task Description",
      "Time Sheet Approved successfully": "Time Sheet Approved successfully",
      "Time Sheet disapproved": "Time Sheet disapproved.",
      "Search By Candidate title": "Search By Candidate title",
      "This phone number doesn't exist": "This phone number doesn't exist",
      "OTP send successfully": "OTP send successfully",
      "Login Successfully": "Login Successfully",
      "Invalid Credentials": "Invalid Credentials",
      "Enter Current Password": "Enter Current Password",
      "Enter New Password": "Enter New Password",
      "Confirm New Password": "Confirm New Password",
      "Cancel": "Cancel",
      "You cannot set the old password again.":"You cannot set the old password again."
    },
    "YearMonth": {
      "Enter Valid Mobile Number":"Enter Valid Mobile Number",
      "Please enter a password with at least 8 characters, including uppercase, lowercase, digits, and any special characters(@$!%*#?&)":"Please enter a password with at least 8 characters, including uppercase, lowercase, digits, and any special characters(@$!%*#?&)",
      "Select payment period above and enter salary in the field below":"Select payment period above and enter salary in the field below",
      "This Company already exist":"This Company already exist",
      "View All Vacancy":"View All Vacancy",
      "Enter Company Website":"Enter Company Website",
      "Enter About Your Company":"Enter About Your Company",
      "My Vacancy":"My Vacancy",
      "Please verify your account":"Please verify your account",
      "Username":"Username",
      "Password":"Password",
      "Vacancies":"Vacancies",
      "Please Enter Credit Point":"Please Enter Credit Point",
      "Not Availability for Part Time":"Not Availability for Part Time",
      "You didn't add any new skill.":"You didn't add any new skill.",
      "New skill addded":"New skill addded",
      "Degree add successfully":"Degree add successfully",
      "Add New Degree":"Add New Degree",
      "Degree":"Degree",
      "You didn't add any new Degree":"You didn't add any new Degree",
      "New Password and Confirm Password does not match":"New Password and Confirm Password does not match",
      "passwordValidation":"A password should be alphanumeric.First letter of the password should be capital.Password must contain a special character (@, $, !, &, etc).Password length must be greater than 8 characters.",
      "You want to delete this Vaccancy?":"You want to delete this Vaccancy?",
      "You created a playlist successfully":"You created a playlist successfully",
      "Your Playlist Title":"Your Playlist Title",
      "previous":"previous",
      "Next":"Next",
      "Post Another Vacancy":"Post Another Vacancy",
      "Password Reset":"Password Reset",
      "password and confirm password doesnot match":"password and confirm password doesnot match",
      "Confirm Password Required":"Confirm Password Required",
      "Password Required":"Password Required",
      "New Company added sucessfully!":"New Company added sucessfully!",
      "Profile Image":"Profile Image",
      "Invalid OTP":"Invalid OTP",
      "Register successfully":"Register successfully",
      "This field may not be blank.":"This field may not be blank.",
      "Notification Got Deleted Successfully":"Notification Got Deleted Successfully",
      "January": "January",
      "February": "February",
      "March": "March",
      "April": "April",
      "May": "May",
      "June": "June",
      "July": "July",
      "August": "August",
      "September": "September",
      "October": "October",
      "November": "November",
      "December": "December",
      "Today": "Today",
      "Yesterday": "Yesterday",
      "a minute ago": "a minute ago",
      "minutes ago": "minutes ago",
      "hours ago": "hours ago",
      "a hour ago": "a hour ago",
      "a day ago": "a day ago",
      " days ago": "days ago",
      "Do You Really Want To Delete Your Account":"Do You Really Want To Delete Your Account?",
      "User does not exists":"User does not exists",
      "phone, username already exist":"phone, username already exist",
      "This phone number doesn't exist":"This phone number doesn't exist",
      "Login Successfully":"Login Successfully",
      "User is deactivated by admin":"User is deactivated by admin",
      "Time sheet downloaded successfully, Please check your download folder":"Time sheet downloaded successfully, Please check your download folder",
      "Space are not allowed":"Space are not allowed",
      "Are you sure you want to Transfer Admin Right?":"Are you sure you want to Transfer Admin Right?",
      "Close":"Close",
      "certificate":"certificate",
      "already exist":"already exist",
      "Are You Sure!":"Are You Sure!",
      "phone, email, username already exist":"telefon, e-post, kasutajanimi on juba olemas",
      "Incorrect Authentication Credentials": "Invalid Credentials",
      "phone, email already exist":"phone, email already exist",
      "email already exist":"email already exist",
      "phone already exist":"phone already exist",
      "You have created a new sub user": "You have created a new sub user",
      "You have updated a sub user's detail":"You have updated a sub user's detail",
      "Admin":"Admin",
      "Sub-User":"Sub-User",
      "Created":"Created",
      "Year":"Year",
      "OTP verified successfully Successfully":"OTP verified Successfully",
      "OTP verified Successfully":"OTP verified Successfully",
      "Login":"Login",
      "Please Enter Current Password":"Please Enter Current Password",
      "Please Enter New Password":"Please Enter New Password",
      "Password Does not Match":"Password Does not Match",
      "You cannot set the old password again":"You cannot set the old password again",
      "Password Reset":"Password Reset",
      "Thank you for contacting our support team. We'll get back to you soon!":"Thank You for connecting our support team. we'll get back to you soon",
      "Please correct the following errors.":"Please correct the following errors.",
      "Password updated successfully":"Password updated successfully",
      "Timesheet Approved Successfully":"Timesheet Approved Successfully",
      "Timesheet Disapproved Successfully":"Timesheet Disapproved Successfully",
      "You do not have enough credits to unlock this profile. Please upgrade your subscription plan":"You do not have enough credits to unlock this profile. Please upgrade your subscription plan",
      "Category add successfully":"Profession add successfully",
      "Please upload file having extensions .jpeg/.jpg/.png only.":"Please upload file having extensions .jpeg/.jpg/.png only."
    }

  },
  "fi": {
    "language": "Finnish",
    "tab": {
      "Recent jobs":"Viimeaikaiset työpaikat",
      "Home": "Koti",
      "My Vacancies": "Vapaat työpaikkani",
      "Post": "Poster",
      "Unlocked Profiles": "Lukitsemattomat Profiilit",
      "My Profile": "Mon Profil"
    },
    "Home": {
      "Candidate near me":"Ehdokkaat lähellä minua",
      "Hey, There": "Hei siellä",
      "Hey,": "Hei,",
      "Credits": "Krediitit",
      "Search by Candidates/categories/Services": "Etsi ehdokkaan /toimiala / palvelun mukaan",
      "Job Categories": "Ammattinimike",
      "Show More": "Näytä lisää",
      "Show Less": "Näytä vähemmän",
      "Your Subscription Info": "Tilauksesi tiedot",
      "Upgrade your subscription to fulfil your requirements with our best plans.": "Päivitä tilauksesi täyttääksesi vaatimuksesi parhailla suunnitelmillamme.",
      "Upgrade your Subscription": "Päivitä tilauksesi",
      "Your profile is incomplete! Please complete your profile to find the right candidate for your job": "Profiilisi on epätäydellinen! Täytä profiilisi löytääksesi oikean ehdokkaan työhösi.",
      "Login Now": "Kirjaudu nyt sisään",
      "Complete Now": "Täytä nyt",
      "Complete Your Profile": "Täydennä profiilisi",
      "Unlocked Profiles": "lukitsematon profiili",
      "All Profiles": "Kaikki profiilit",
      "Candidates Near Me": "Ehdokkaat lähellä minua",
      "View All": "Näytä kaikki",
      "Recommended Candidates": "Suositellut ehdokkaat",
      "Add to a List": "Lisää listaan",
      "Create New List": "Luo uusi lista",
      "Add": "Lisää",
      "Select Round": "Valitse kierros",
      "Use my Current Location": "Käytä nykyistä sijaintiani",
      "Recent Locations": "Viimeaikaiset sijainnit",
      "Within 5 KM Radius": "5 km:n säteellä",
      "Within 10 KM Radius": "10 km:n säteellä",
      "Within 50 KM radius": "50 km:n säteellä",
      "Within 100 KM Radius": "100 km:n säteellä",
      "Notifications": "Ilmoitukset",
      "No New Notification Found": "Ei uusia ilmoituksia"
    },
    "JobCategoriesdata": {
      "Candidate": "Ehdokas",
      "Candidates": "Ehdokkaat"
    },
    "BlackCard": {
      "Premium": "Premium",
      "Verified": "Vahvistettu",
      "About Me": "Tietoja minusta",
      "Experience": "Kokemus",
      "Experience Required": "Vaadittu kokemus",
      "Employment Type": "Työsopimuksen tyyppi",
      "Available": "Saatavilla",
      "Expected Salary": "Palkkatoive",
      "Skills": "Taidot",
      "Education": "Koulutus",
      "Passout Year": "Valmistumisvuosi",
      "Licenses": "Lisenssit",
      "Contact Details Locked": "Yhteystiedot lukittu",
      "See Full Details": "Näytä koko profiili",
      "Less Than 1 KM Away": "Alle 1 km päässä",
      "KM Away": "km päässä",
      "Availability for Part Time ": "Osapäivätyön saatavuus ",
      "You": "Sinä",
      "Match": "Sopivuus",
      "Add To A List": "Lisää listalle",
      "Create New List": "Luo uusi lista",
      "Select Vacancy": "Valitse avoin työpaikka",
      "Add": "Lisää",
      "Select Round": "Valitse vaihe",
      "Hire": "Palkkaa",
      "Please unlock the profile first": "Lukitse profiili ensin",
      "Please do Login/Sign up": "Kirjaudu sisään tai rekisteröidy",
      "Are you sure to unlock the profile": "Oletko varma, että haluat avata profiilin",
      "Write your lists": "Kirjoita listasi"
    },
    "RecommendedComp": {
      "Verified": "Vahvistettu",
      "Available": "Saatavilla",
      "Total Experience": "Kokemus (Työvuodet)",
      "Year": "Vuosia",
      "Years": "Vuotta",
      "Current Location": "Tämänhetkinen sijaintis",
      "Miles Away": "Mailin päässä",
      "Package": "Palkka",
      "Match": "Vastaavuus",
      "% Match": "% Vastaavuus",
      "Last seen": "Viimeksi nähty",
      "ago": "sitten",
      "KM Away": "KM päässä"
    },
    "UnlockedProfileComp": {
      "KM": "KM",
      "Match": "Vastaavuus",
      "Unlocked on": "Avattu",
      "Total Experience": "Kokemus",
      "Current Location": "Tämänhetkinen sijainti"
    },
    "Message": {
      "Filters": "Suodattimet",
      "Search by Candidates/Keyword": "Etsi ehdokkaiden / avainsanojen perusteella",
      "Messages": "Viestit",
      "No Messages Found": " Ei viestejä löytynyt",
      "You": "Sinä",
      "jobseeker":"Työnhakija",
      "Today":"Tänään"
    },
    "SearchEvents": {
      "Subscription Details": "Tilauksen tiedot",
      "Looking for": "Etsii",
      "Select Required Skills": "Valitse vaaditut taidot",
      "Employment Type": "Työsopimuksen tyyppi",
      "Part Time": "Osapäivätyö",
      "Full Time": "Kokopäivätyö",
      "Contract": "Sopimus",
      "Gender": "Sukupuoli",
      "Male": "Mies",
      "Female": "Nainen",
      "Experience": "Kokemus",
      "Years": "Vuotta",
      "Maximum Distance": "Maksimietäisyys",
      "Km": "Km",
      "Age": "Ikä",
      "Salary": "Palkka",
      "K": "K",
      "Candidate Type": "Ehdokastyyppi",
      "Frees": "Vapaa",
      "Verified": "Vahvistettu",
      "Premium": "Premium",
      "Search Now": "Hae nyt",
      "Free": "Ilmainen",
      "VIP": "VIP",
      "Current Plan": "Nykyinen suunnitelma"
    },
    "UnlockedPro": {
      "Unlocked Profiles": "lukitsematon profiili",
      "Search by Candidate Name": "Hae kandidaatin nimellä",
      "Filters": "Suodattimet",
      "Verified": "Vahvistettu",
      "Available": "Saatavilla",
      "Total Experience": "Kokemus yhteensä",
      "Years": "Vuodet",
      "Current Location": "Nykyinen sijainti",
      "KM Away": "KM päässä",
      "Package": "Paketti",
      "Match": "Vastaavuus",
      "Unlocked on": "Avattu",
      "Add to a List": "Lisää listalle",
      "Create New List": "Luo uusi lista",
      "No Data Found": "Ei tuloksia"
    },
    "CreditHistory": {
      "Per Credit Amount":"Luottosummaa kohti",
      "Enter No. Credits":"Anna krediittien määrä",
      "Total Amount":"Kokonaismäärä",
      "Credit balance": "Credit balance",
      "Credit balance": "Luottosaldo",
      "Available Credits": "Saatavilla olevat hyvitykset",
      "Used Credits": "Käytetyt hyvitykset",
      "Total Credits": "Hyvitysten kokonaismäärä",
      "Subscription Details": "Tilauksen tiedot",
      "Plan": "Suunnitelma",
      "Days Left": "Päiviä jäljellä",
      "days Validity": "päivää voimassaolo",
      "Purchased Date": "Ostopäivämäärä",
      "Validity": "Voimassaoloaika",
      "days": "päivää",
      "Amount": "Summa",
      "Credit Balance & History": "Luottosaldo & historia",
      "Payment Mode": "Maksutapa",
      "Credit History": "Luottohistoria",
      "Recharge Credit": "Lisää hyvityksiä",
      "Select no. of Credits": "Valitse hyvitysten määrä",
      "Credits": "Hyvitykset",
      "Pay": "Maksa",
      "Premium": "Premium",
      "Unlocked By": "Unlocked By",
      "Upgrade Plan": "Tilauksen päivitys",
      "Credit Top-up": "Krediittien lisäys",
      "End Date":"Loppupäivä"
    },
    "PaymentSuccesfull": {
      "Thank you !": "Kiitos !",
      "Your Payment was Successfull": "Maksusi onnistui",
      "Your Transcation ID: 1236589742 & Your plan Renews on": "Transaktiotunnus: 1236589742 & tilauksesi uusitaan päivämäärään",
      "Post Vacancy": "Ilmoita avoin työpaikka",
      "Explore Candidates": "Tutustu kandidaatteihin"
    },
    "Subscription": {
      "Free": "Ilmainen",
      "Vip": "VIP",
      "Premium": "Premium",
      "Current Plan": "Nykyinen tilaus",
      "€ 300/pm": "€ 300/kk",
      "Upgrade to": "Päivitä",
      "€ 499/pm": "€ 499/kk",
      "Upgrade Now": "Päivitä nyt",
      "Credit": "Hyvitykset",
      "Payment successful": "Maksu onnistui"
    },
    "RecommBlackCard": {
      "month subscription":"kk tilaus",
      "Select Vacancy": "Valitse avoin työpaikka",
      "Add to a List": "Lisää listalle",
      "Create New List": "Luo uusi lista",
      "Add": "Lisää",
      "Select Round": "Valitse kierros",
      "10 %": "10 %",
      "%": "%",
      "Match": "Sopivuus",
      "Hire": "Palkkaa"
    },
    "Hiring": {
      "Select Vacancy": "Valitse avoin työpaikka",
      "Hiring Details": "Palkkaus tiedot",
      "Vacancy Details": "Avoin työpaikka tiedot",
      "Job Duration": "Työn kesto",
      "Submit": "Lähetä",
      "Add to a List": "Lisää listalle",
      "Create New List": "Luo uusi lista",
      "Add": "Lisää"
    },
    "UnlockedProfileBlackScreen": {
      "Add to a List": "Lisää listalle",
      "Create New List": "Luo uusi lista",
      "Add": "Lisää",
      "Done": "Valmis",
      "Select Round": "Valitse kierros",
      "Match": "Sopivuus",
      "Hire": "Palkkaa"
    },
    "CandidateNearMapScreen": {
      "Less than 1 Miles away": "Alle 1 mailin päässä",
      "Miles away": "Mailia päässä",
      "10% Match": "10% Sopivuus",
      "% Match": "% Sopivuus",
      "View Profile": "Katso profiili",
      "10%": "10%",
      "%": "%"
    },
    "SearchScreen": {
      "Search by candidates title, industry Title":"Hae ehdokkaiden tittelin, toimialan nimikkeen mukaan",
      "Filters": "Suodattimet",
      "Experience Between": "Kokemus välillä",
      "Year": "Vuosia",
      "Within": "Sisällä",
      " mi of Radius": " mailin säteellä",
      "Salary Between": "Palkka välillä",
      "K": "K",
      "No Data Found": "Tietoja ei löytynyt",
      "Select Vacancy": "Valitse avoin työpaikka",
      "Select Round": "Valitse kierros",
      "Add to a List": "Lisää listalle",
      "Create New List": "Luo uusi lista",
      "Add": "Lisää",
      "10 % Add": "10 % lisäys",
      "%": "%",
      "Match": "Sopivuus",
      "Hire": "Palkkaa"
    },
    "EditProfile": {
      "Upload image": "Lataa kuva",
      "Personal Information": "Henkilökohtaiset tiedot",
      "Submit": "Lähetä"
    },
    "HireDetails": {
      "Post Settings":"Hakuilmoituksen asetukset",
      "Hires": "Palkatut henkilöt",
      "View Full Profile": "Katso koko profiili",
      "Time Sheet": "Työaikalista",
      "OnGoing Job": "Meneillään oleva työpaikka",
      "Hours Worked": "Tuntia työskennelty",
      "Hours": "Tuntia",
      "Job Duration": "Työn kesto",
      "Hired Date": "Palkattu päivämäärä",
      "Verified": "Vahvistettu"
    },
    "SuccessfulHire": {
      "Your Hire Request to ramesh has been sent Successfully": "Palkkauspyyntösi rameshille on lähetetty onnistuneesti",
      "Resume Hiring": "Jatka palkkausta"
    },
    "ApplicantsDetails": {
      "Filters": "Suodattimet:",
      "Availability for Part Time ": "Saatavuus osa-aikatyöhön",
      "99% ": "99% ",
      "match": "Sovita",
      "Hire": "Palkkaa"
    },
    "NoDataFound": {
      "Opps ! ": "Hups! ",
      "No Data Found ": "Tietoja ei löytynyt",
      "Post New Vacancy": "Luo uusi avoin työpaikka"
    },
    "PostNewVacancy": {
      "Enter Address":"Anna osoite",
      "All times are in your local your local (PTS)": "Kaikki ajat ovat paikallisessa aikavyöhykkeessäsi (PTS)",
      "Confirm to Reject": "Vahvista hylkääminen",
      "Confirm to Accept": "Vahvista hyväksyminen",
      "Select Required Skills": "Valitse vaaditut taidot",
      "Job Description": "Työnkuvaus",
      "Select Required Experience": "Vaadittu kokemus",
      "No Of Vacancies": "Avoimien työpaikkojen lukumäärä",
      "Job Duration(In Days)": "Työn kesto (päivinä)",
      "Enter Compensation Amount": "Syötä palkkauksen määrä",
      "Post Vacancy": "Lähetä työpaikkailmoitus",
      "Enter Job Title": "Syötä työnimike",
      "Company Name (Please Update Your Profile)": "Yrityksen nimi (päivitä profiilisi)",
      "Select Job Category": "Valitse Ammatin tyyppi",
      "Job Details": "Työn tiedot",
      "Is this vacancy Urgent ? ": "Onko tämä avoin työpaikka kiireellinen?",
      "Is Liscense Requrired ?": "Tarvitaanko lisenssi?",
      "Employment Details": "Työsopimuksen tyyppi",
      "Compensation Details": "Palkkaustiedot",
      "Company Details": "Yrityksen tiedot",
      "Work Location": "Työpaikan sijainti",
      "Contact Person Name": "Yhteyshenkilön nimi",
      "Contact Number": "Yhteyshenkilön puhelinnumero",
      "Select Highest Degree": "Valitse korkein tutkinto",
      "Qualification Required": "Vaadittu pätevyys",
      "Highest Degree Completion Year": "Korkeimman tutkinnon suoritusvuosi",
      "Maximum Application Required": "Enimmäis työnhakijamäärä",
      "Enter Search Radius (In Meters)": "Anna hakusäde (kilometreissä)",
      "Enter Short Description": "Syötä lyhyt kuvaus",
      "Post Setting": "Postauksen asetukset",
      "Review & Post Vacancy": "Tarkasta ja luo avoin työpaikka"
    },
    "PostSuccessFulMessage": {
      "Edit Vacancy": "Muokkaa ilmoitusta",
      "Post SuccessFul": "Ilmoitus julkaistu",
      "Vacancy Posted Successfully !": "Ilmoitus julkaistu onnistuneesti!",
      "Post Another Vacancy": "Lisää uusi ilmoitus"
    },
    "MyProfile": {
      "Update Now":"Päivitä nyt",
      "Update":"Päivitä",
      "Welcome to Catzapp": "Tervetuloa Catzapp:iin",
      "Login": "Kirjaudu",
      "Log Out": "Kirjaudu ulos",
      "My Profile": "Profiilini",
      "Create an Account": "Luo tili",
      "My Subscriptions": "Tilaukseni",
      "My Lists": "Minun listani",
      "My Vacancies": "Ilmoitukseni",
      "My Unlocked Candidates": "Avatut ehdokkaat",
      "Sub Users": "Ala-käyttäjät",
      "Settings": "Asetukset",
      "Language": "Kieli",
      "Alert/Notifications": "Ilmoitukset",
      "Privacy & Policies": "Tietosuoja ja käytännöt",
      "Contact Support": "Ota yhteyttä tukeen",
      "Update Profile": "Päivitä profiili",
      "Upload Image": "Lataa kuva",
      "Personal Information": "Henkilötiedot",
      "Submit": "Lähetä",
      "Upolad Your Company Image": "Lataa yrityksesi kuva",
      "About Your Company": "Tietoa yrityksestäsi",
      "Company Location": "Yrityksen sijainti",
      "Company Website": "Yrityksen verkkosivut",
      "Company Name": "Yrityksen nimi",
      "Add Your Company": "Lisää yrityksesi",
      "Select Company": "Valitse yritys",
      "Email": "Sähköposti",
      "Last Name": "Sukunimi",
      "First Name": "Etunimi",
      "My List Screen": "Listani näkymä",
      "Select Language": "Valitse kieli"
    },
    "NoUserFound": {
      "Opps !": "Hups !",
      "No Sub User Found": "Alakäyttäjiä ei löytynyt",
      "Create Sub User": "Luo alakäyttäjä"
    },
    "NewSubUser": {
      "User Details": "Alakäyttäjän tiedot",
      "Enter User Name": "Syötä käyttäjänimi",
      "Enter First Name": "Syötä etunimi",
      "Enter Last Name": "Syötä sukunimi",
      "Enter Email Address": "Syötä sähköpostiosoite",
      "Enter Mobile Number": "Syötä puhelinnumero",
      "Enter Password": "Syötä salasana",
      "Confirm Password": "Vahvista salasana",
      "Update Sub User ": "Päivitä alakäyttäjä",
      "Create Sub User ": "Luo alakäyttäjä",
      "Enter Full Name": "Kirjoita koko nimi"
    },
    "MyList": {
      "No Data Found": "Dataa ei löytynyt",
      "Remove": "Poista",
      "Available": "Saatavilla"
    },
    "Settings": {
      "Email Notification": "Sähköposti-ilmoitukset",
      "Notification": "Ilmoitukset",
      "Update Password": "Päivitä salasana"
    },
    "PrivacyPolicies": {
      "PRIVACY POLICY": "TIETOSUOJASELOSTE",
      "Welcome to Recruiter": "Tervetuloa rekrytoijaan",
      "1. Introduction": "1. Johdanto",
      "2. Definitions": "2. Määritelmät",
      "3. Information Collection and Use": "3. Tietojen kerääminen ja käyttö",
      "4. Types of Data Collected ": "4. Kerätyt tietotyypit ",
      "5. Types of Data Collected": "5. Kerätyt tietotyypit"
    },
    "ContactSupport": {
      "Submit": "Lähetä"
    },
    "MyListsScreen": {
      "Salery- Compensation":"Korvaus - Palkkio",
      "Required": "Vaadittu",
      "Immediately": "Välittömästi",
      "Total Experience": "Vaadittu kokemus",
      "Years": "Vuotta",
      "Year": "Vuosia",
      "Work Location": "Työpaikan sijainti",
      "Package": "Palkka"
    },
    "PlayListBlackCard": {
      "Select Vacancy": "Valitse avoin paikka",
      "Select Round": "Valitse kierros",
      "Add to a List ": "Lisää listalle ",
      "Create New List ": "Luo uusi lista ",
      "Add": "Lisää ",
      "Done": "Valmis",
      "Match": "Match",
      "Add Your List": "Lisää oma lista"
    },
    "SignUp": {
      "Enter Your Name": "Syötä nimesi",
      "Enter Your Phone Number": "Syötä puhelinnumerosi",
      "Enter Your Email": "Syötä sähköpostiosoitteesi",
      "Enter Password": "Syötä salasana",
      "Enter Valid Password": "Syötä kelvollinen salasana",
      "Password Does Not Match": "Salasanat eivät täsmää",
      "Set a password": "Aseta salasana",
      "Confirm password ": "Vahvista salasana ",
      "Confirm": "Vahvista"
    },
    "LoginPassword": {
      "Login": "Kirjaudu sisään",
      "Forgot Password": "Unohtuiko salasana",
      "Do not have an account?": "Ei käyttäjätiliä?",
      "SignUp": "Rekisteröidy",
      "SKIP": "OHITA",
      "Please Enter MobileNumber & Password": "Syötä puhelinnumero ja salasana",
      "Please Enter Your Mobile Number": "Syötä puhelinnumerosi",
      "Please Enter Your Password": "Syötä salasanasi",
      "Please Enter Valid Password": "Syötä kelvollinen salasana",
      "Please enter your mobile number to complete the login process.": "Syötä puhelinnumerosi kirjautumisprosessin loppuun saattamiseksi.",
      "Enter Your Mobile Number": "Syötä puhelinnumerosi",
      "Enter Your Password": "Syötä salasanasi",
      "OTP": "OTP",
      "Login to Catzapp Recruiter": "Kirjaudu Catzapp Recruiteriin"
    },
    "ChangePassword": {
      "Please Enter Your New Password & Confirm Password": "Syötä uusi salasana ja vahvista se",
      "Please Enter Your New Password": "Syötä uusi salasana",
      "Please Enter Valid password": "Syötä kelvollinen salasana",
      "Please Enter Confirm Password": "Vahvista salasana",
      "Password dosen't Match": "Salasanat eivät täsmää",
      "Reset Your Password": "Palauta salasanasi",
      "Set a password": "Syötä salasanasi",
      "Confirm password": "Vahvista salasanasi",
      "Enter Your New password": "Syötä uusi salasanasi",
      "Confirm Your New password": "Vahvista uusi salasanasi"
    },
    "ResetPassword": {
      "Please Enter Mobile Number": "Syötä puhelinnumerosi",
      "Please Enter Otp": "Syötä OTP",
      "Submit OTP": "Vahvista OTP",
      "We Have sent One Time Password to": "Olemme lähettäneet yhden kertakäyttösalasanan osoitteeseen"
    },
    "interOtp": {
      "we have sent an OTP to": "Olemme lähettäneet yhden kertakäyttösalasanan osoitteeseen",
      "Did Not Receive Code Yet?": "Etkö ole vielä vastaanottanut koodia?",
      "Resend OTP": "Lähetä OTP uudelleen",
      "Please Enter OTP": "Syötä OTP",
      "Submit": "Vahvista"
    },
    "forgetPassword": {
      "Send OTP": "Lähetä OTP",
      "Get Password": "Saada salasana",
      "Enter Mobile Number": "Syötä puhelinnumerosi",
      "Please enter your mobile number to generate OTP": "Kirjoita matkapuhelinnumerosi OTP:n luomiseksi",
      "Please Enter Your Mobile Number": "Syötä puhelinnumerosi"
    },
    "myVacancy": {
      "Search by Job Title": "Etsi työnimikkeen perusteella",
      "My Vacancies": "Omat avoimet työpaikat",
      "No Data Found": "Ei tuloksia",
      "Applications": "Hakemukset",
      "Edit": "Muokkaa",
      "Delete": "Poistu",
      "Required": "Vaadittu",
      "Immediately": "Välittömästi",
      "Posted": "Julkaistu",
      "ago": "sitten",
      "Applicants": "Hakijat",
      "Hire": "Palkkaa",
      "Apply Filters": "Käytä suodattimia",
      "Clear All": "Tyhjennä kaikki",
      "Application": "Hakemus",
      "Make Admin":"Nimeä ylläpitäjäksi"
    },
    "new": {
      "No Required Immediately":"Ei heti tarvetta",
      "Please Select date range":"Ole hyvä ja valitse ajanjakso",
      "About Company": "Tietoa yrityksestä",
      "Latter": "Jälkimmäinen",
      "All": "Kaikki",
      "Not Premium": "Ei Premium",
      "Premium": "Premium",
      "Buy Credit to Unlock the Candidates and Proceed further with the process to send messages, chat or call.": "Osta luottoja avataksesi hakijan tiedot ja jatkaaksesi viestintää, chatin tai puhelun lähettämistä.",
      "Are you sure you want to delete this chat?": "Oletko varma, että haluat poistaa tämän keskustelun?",
      "Recommended Profiles": "Suositellut profiilit",
      "Map View": "Karttanäkymä",
      "List View": "Listanäkymä",
      "Read": "Lue",
      "2 Credits will get deducted. Are you sure to unlock the profile?": "2 luottoa vähennetään. Oletko varma, että haluat avata tiedot?",
      "Subscribe Now": "Tilaa nyt",
      "Please unlock profile first": "Avaa profiili ensin",
      "You do not have a login yet, Please do login/Signup to continue.": "Sinulla ei ole vielä kirjautumistietoja, kirjaudu sisään tai rekisteröidy jatkaaksesi.",
      "Signup/Login": "Rekisteröidy/Kirjaudu sisään",
      "Welcome to Catzapp": "Tervetuloa Catzappiin",
      "Create Account": "Luo tili",
      "Or": "Tai",
      "Sign In": "Kirjaudu sisään",
      "Skip": "Ohita",
      "Yes": "Kyllä",
      "No": "Ei",
      "Part Time": "Osapäiväinen",
      "Full Time": "Kokopäiväinen",
      "Contract": "Sopimus",
      "Daily": "Päivittäin",
      "Weekly": "Viikoittain",
      "Monthly": "kuukausi",
      "Yearly": "Vuotuisesti",
      "Please Enter Category Name":"Anna luokan nimi",
      "Upload Category Image": "Lataa ammatin kategoriasta",
      "From Date": "Alkaen päivä",
      "To Date": "Päivä asti",
      "Selected": "Valittu",
      "Rejected": "Hylätty",
      "First Round": "Ensimmäinen kierros",
      "Second Round": "Toinen kierros",
      "Type Message": "Kirjoita viesti",
      "Subject": "Aihe",
      "Enter your Description": "Syötä kuvaus",
      "Please Unlock Profile First": "Avaa profiili ensin",
      "Please Select Vacancy": "Valitse avoin paikka",
      "Please Select From Date": "Valitse alkaen päivä",
      "Please Select To Date": "Valitse päivä asti",
      "Please Enter Details": "Syötä tiedot",
      "Please Enter valid Email": "Syötä validi sähköposti",
      "Passwords should be a minimum of eight characters in length": "Salasanan tulee olla vähintään 8 merkkiä pitkä",
      "Please Confirm Your Password": "Vahvista salasanasi",
      "Password Does Not Match": "Salasanat eivät täsmää"
    },
    "FinalFinal": {
      "You have created a hire request": "Olet luonut vuokrauspyynnön",
      "Hire request already exists": "Vuokrapyyntö on jo olemassa",
      "Please Upload Image to add new categories": "Lähetä kuva lisätäksesi uusia Ammatti",
      "Please select liscense required": "Valitse vaadittava lisenssi",
      "Want to post vacancy please upgrade subscrption": "Jos haluat julkaista avoimen työpaikan, päivitä tilaus",
      "Please enter number of vacancy": "Syötä vapaan paikan numero",
      "Please enter search radius": "Anna hakusäde",
      "Enter Your Email Address": "Syötä sähköpostiosoitteesi",
      "Enter Your Phone Number": "Syötä puhelinnumerosi",
      "Please Enter Title": "Syötä otsikko",
      "Please Enter Description": "Syötä kuvaus",
      "Enter Your First Name": "Syötä etunimesi",
      "Enter Your Last Name": "Syötä sukunimesi",
      "Password must be minimum of 8 character": "Salasanan on oltava vähintään 8 merkkiä pitkä",
      "Enter Confirm Password": "Syötä salasana uudelleen",
      "Enter Valid Password (password must be combination of letters, numbers and special character": "Syötä kelvollinen salasana (salasanan on oltava kirjaimien, numeroiden ja erikoismerkkien yhdistelmä)",
      "Please Enter First Name": "Syötä etunimesi",
      "Please Enter Last Name": "Syötä sukunimesi",
      "Please Enter Email": "Syötä sähköpostiosoitteesi",
      "Please Select or Add a Company": "Valitse tai lisää yritys",
      "Please Select Profile Picture": "Valitse profiilikuva",
      "Please enter Job Title": "Syötä työnimike",
      "Please select Company": "Valitse yritys",
      "Please Select Company Image": "Valitse yrityksen kuva",
      "Please Enter Company Detail": "Syötä yrityksen tiedot",
      "Please select Job Category": "Valitse ammattityyppi",
      "Please select required Experience": "Valitse vaadittu kokemus",
      "Please enter Job Description": "Syötä työn kuvaus",
      "Please enter short description": "Syötä lyhyt kuvaus",
      "Please select Skills": "Valitse taidot",
      "Please select urgent vacancy": "Valitse kiireellinen avoin työpaikka",
      "Please select license required": "Valitse vaadittava lisenssi",
      "Please select to date": "Valitse päivämäärä",
      "Please select from date": "Valitse päivämäärä",
      "Please enter maximum number of application": "Syötä maksimimäärä hakemuksia",
      "Please select category image": "Valitse Ammatin kuva",
      "Please select Highest Degree": "Valitse korkein tutkinto",
      "Please enter contact person number": "Syötä yhteyshenkilön numero",
      "Please enter contact person name": "Syötä yhteyshenkilön nimi",
      "Please enter Job Location": "Syötä työpaikan sijainti",
      "Please enter Compensation Amount": "Syötä korvausmäärä",
      "Please enter Compensation Details": "Syötä korvaustiedot",
      "Please enter Job Duration": "Syötä työn kesto",
      "Please select employment details": "Valitse Työsopimuksen tyyppi",
      ".png Images are not supported": ".png-kuvia ei tueta",
      "Please Enter Company Name": "Syötä yrityksen nimi",
      "Please Enter Company Website": "Syötä yrityksen verkkosivusto",
      "OK": "OK"


    },
    "LastL": {
      "Stored Messages": "Tallennetut viestit",
      "Unlocked By": "Avattu",
      "User Type": "Käyttäjätyyppi",
      "Search": "Haku",
      "Filter By": "Suodata",
      "Sort By": "Lajittele",
      "Experience": "Kokemus",
      "Location Radius": "Sijaintisäde",
      "Matching Percentage": "Vastaavuusprosentti",
      "Package Range": "Paketti alue",
      "Passout Year": "Valmistumisvuosi",
      "Distance": "Etäisyys",
      "Search by Area/Street/City Name": "Hae alueen/kadun/kaupungin nimen mukaan",
      "Please select Highest Degree completion year": "Valitse korkeimman tutkinnon valmistumisvuosi"
    },
    "Lastest": {
      "NoAccount": "Eikö ole tiliä?",
      "Login": "Kirjaudu sisään",
      "Sec": "Sekuntti",
      "Please Wait": "Ole hyvä. Odota.",
      "UpGradePlan": "Jos haluat nähdä hakijan, ole hyvä ja päivitä suunnitelmasi",
      "Monthly": "Kuukausittain",
      "ProfileUpdate": "Profiili päivitetty onnistuneesti",
      "NewCategory": "Lisää uusi ammatti",
      "Submit": "Hyväksy",
      "Unlocked": "Lukitsematon (ei valittu?)",
      "First Round": "Ensimmäinen kierros",
      "Second Round": "Toinen kierros",
      "Selected": "Valittu",
      "Rejected": "Hylätty",
      "CandidateAlreadyExist": "Hakija on olemassa tällä listalla",
      "Monday": "maanantai",
      "Tuesday": "tiistai",
      "Wednesday": "keskiviikko",
      "Thursday": "torstai",
      "Friday": "perjantai",
      "Saturday": "lauantai",
      "Sunday": "sunnuntai",
      "LanguageAlert": "Ole hyvä sulje sovellus ja käynnistä uudelleen vaihtaaksesi sovelluksen",
      "Hire": "Palkkaa",
      "Hirerequest": "Olet luonut palkkauspyynnön",
      "DeleteJob": "Oletko varma että haluat poistaa tämän työn",
      "Address": "Osoite",
      "Jobs": "työpaikkoja",
      "Login Successfully": "kirjautuminen onnistuneesti",
      "Hours": "Tuntia",
      "Premium": "ensiluokkainen",
      "Minutes": "Minuutit",
      "Invalid credentials": "Virheelliset kirjautumistiedot",
      "Status : Accepted": "Tila: Hyväksytty",
      "Status : Rejected": "Tila: Hylätty",
      "Unread": "Lukematon"
    },
    "Newtranslation": {
      "FREE":"VAPAA",
      "My Subcription":"Tilaukseni",
      "job": "Katso työpaikkoja,",
      "HireRequest": "Katso palkkauspyyntö",
      "Timesheet": "Katso työaikalomake",
      "Message": "Katso viesti",
      "Unlocked by recruiter": "Katso rekrytoijan lukituksen avaama",
      "Monthly Plan": "Kuukausitilaus",
      "Half Yearly Plan": "Puolivuositilaus",
      "Yearly Plan": "Vuositilaus",
      "valid for ": "voimassa",
      "days": "päivää",
      "Feature": "Piirre",
      "Includescredits": "Sisältää 10 krediittiä kuukaudessa.",
      "Credits can be carried forward each month": "Krediitit voidaan siirtää seuraavalle kuukaudelle",
      "Upgrade Subcription": "Päivitä tilaus",
      "Newcandidate": "Uusi ehdokas kuljettajaksi, tarkista nyt",
      "No relevant candidate found": "Sopivuusa ehdokasta ei löytynyt",
      "Years of": "Vuodet",
      "Candidates": "Ehdokkaat",
      "The payment has been canceled": "Maksu on hylätty",
      "Applicant already exist": "Hakija on jo olemassa",
      "The payment method was setup successfully": "Maksutapa päivitetty onnistuneesti",
      "Your Hire Request has been sent successfully": "Palkkausehdotuksesi lähetetty onnistuneesti",
      "Slot Available": "Paikka saatavilla",
      "Task Description": "Tehtäväkuvaus",
      "Time Sheet Approved successfully": "Työaikataulukko hyväksytty onnistuneesti",
      "Time Sheet disapproved": "Työaikataulukko hylätty",
      "Search By Candidate title": "Haku hakijan ammatin mukaan",
      "This phone number doesn't exist": "Puhelinnumeroa ei ole",
      "OTP send successfully": "KKSS lähetetty onnistuneesti",
      "Login Successfully": "Kirjauduttu onnistuneesti",
      "Invalid Credentials": "kelvottomat tunnisteet",
      "Enter Current Password": "Kirjoita olemassa oleva salasana",
      "Enter New Password": "Kirjoita uusi salasana",
      "Confirm New Password": "Vahvista uusi salasana",
      "Cancel": "Peruuta",
      "You cannot set the old password again.":"Et voi asettaa vanhaa salasanaa"
    },
    "YearMonth": {
      "Enter Valid Mobile Number":"Anna kelvollinen matkapuhelinnumero",
      "Select payment period above and enter salary in the field below":"Valitse palkanmaksujakso ja kirjoita alla olevalle kentälle palkka",
      "This Company already exist":"Tämä yritys on jo olemassa",
      "View All Vacancy":"Katso vapaat työpaikkani",
      "Enter Company Website":" Yrityksesi verkkosivu",
      "Enter About Your Company":"Tietoja yrityksestäsi",
      "My Vacancy":"Minun työpaikkani",
      "Please verify your account":"Vahvista tilisi",
      "Username":"Käyttäjätunnus",
      "Password":"Salasana",
      "Vacancies":"Avoimet työpaikat",
      "Please Enter Credit Point":"Anna luottopiste",
      "Not Availability for Part Time":"Ei saatavilla osa-aikaisesti",
      "You didn't add any new skill.":"et lisännyt mitään uutta taitoa",
      "New skill addded":"Uusi taito lisätty",
      "Degree add successfully":"Tutkinnon lisäys onnistui",
      "Add New Degree":"Lisää uusi tutkinto",
      "Degree":"tutkinto",
      "You didn't add any new Degree":"Et lisännyt uusia tutkintoja",
      "New Password and Confirm Password does not match":"Uusi salasana ja Vahvista salasana eivät täsmää",
      "passwordValidation":"Salasanan tulee olla aakkosnumeerinen.Salasanan ensimmäisen kirjaimen tulee olla iso.Salasanan tulee sisältää erikoismerkki (@, $, !, & jne.).Salasanan pituuden on oltava yli 8 merkkiä.",
      "Are You Sure!":"Oled sa kindel!",
      "You want to delete this Vaccancy?":"Haluatko poistaa tämän vapaan työpaikan?",
      "You created a playlist successfully":"Loit soittolistan onnistuneesti",
      "Your Playlist Title":"Soittolistasi nimi",
      "previous":"Edellinen",
      "Next":"Seuraava",
      "Post Another Vacancy":"Ilmoita toinen työpaikka",
      "Password Reset":"Salasanan nollaus",
      "password and confirm password doesnot match":"salasana ja vahvista salasana eivät täsmää",
      "Confirm Password Required":"Vahvista salasana vaaditaan",
      "Password Required":"Salasana vaaditaan",
      "New Company added sucessfully!":"Uusi yritys lisätty onnistuneesti",
      "Profile Image":"Profiilikuva",
      "Invalid OTP":"Virheellinen OTP",
      "Register successfully":"Rekisteröidy onnistuneesti",
      "This field may not be blank.":"Tämä kenttä ei voi olla tyhjä.",
      "Notification Got Deleted Successfully":"Ilmoitus poistettiin onnistuneesti",
      "January": "jaanuaril",
      "February": "veebruar",
      "March": "märtsil",
      "April": "aprill",
      "May": "mai",
      "June": "juunini",
      "July": "juulil",
      "August": "elokuu",
      "September": "septembril",
      "October": "oktoober",
      "November": "novembril",
      "December": "detsembril",
      "Today": "Tänään",
      "Yesterday": "Eilen",
      "a minute ago": "minuutti sitten",
      "minutes ago": "minuuttia sitten",
      "hours ago": "tunteja sitten",
      "a hour ago": "tunti sitten",
      "a day ago": "päivä sitten",
      " days ago": "päiviä sitten",
      "Do You Really Want To Delete Your Account":"Haluatko todella poistaa tilisi?",
      "phone, username already exist":"puhelinnumero, käyttäjätunnus on jo olemassa",
      "User does not exists":"Käyttäjää ei ole olemassa",
      "This phone number doesn't exist":"Tätä puhelinnumeroa ei ole olemassa",
      "Login Successfully":"Kirjaudu sisään onnistuneesti",
      "User is deactivated by admin":"Järjestelmänvalvoja on poistanut käyttäjän käytöstä",
      "Time sheet downloaded successfully, Please check your download folder":"Aikataulukon lataus onnistui. Tarkista latauskansiosi",
      "Space are not allowed":"Tilaa ei sallita",
      "Are you sure you want to Transfer Admin Right?":"Oletko varma, että haluat siirtää järjestelmänvalvojan oikeuden?",
      "Close":"Sulje",
      "certificate":"todistus",
      "already exist":"on jo olemassa",
      "phone, email, username already exist":"puhelinnumero, sähköpostiosoite, käyttäjätunnus on jo olemassa",
      "Incorrect Authentication Credentials": "kelvottomat tunnisteet",
      "Please correct the following errors.":"Korjaa seuraavat virheet.",
      "phone, email already exist":"puhelin, sähköposti on jo olemassa",
      "email already exist":"sähköposti on jo olemassa",
      "phone already exist":"puhelin on jo olemassa",
      "You have created a new sub user": "Olet luonut uuden alikäyttäjän",
      "You have updated a sub user's detail":"Olet päivittänyt alikäyttäjän tiedot",
      "Admin":"Admin",
      "Sub-User":"alikäyttäjä",
      "Created":"Luotu",
      "Year":"vuosi",
      "OTP verified successfully Successfully":"OTP varmistettu onnistuneesti",
      "OTP verified Successfully":"OTP varmistettu onnistuneesti",
      "Login":"Kirjaudu sisään",
      "Please Enter Current Password":"Syötä nykyinen salasana",
      "Please Enter New Password":"Anna uusi salasana",
      "Password Does not Match":"Salasana ei täsmää",
      "You cannot set the old password again":"Et voi asettaa vanhaa salasanaa uudelleen",
      "Password Reset":"Salasanan nollaus",
      "Thank you for contacting our support team. We'll get back to you soon!":"Kiitos yhteydenotosta tukitiimiimme. Palaamme asiaan pian.",
      "Password updated successfully":"Salasana päivitetty onnistuneesti",
      "Timesheet Approved Successfully":"Työaikalomake hyväksytty onnistuneesti",
      "Timesheet Disapproved Successfully":"Työaikalomake hylätty onnistuneesti",
      "You do not have enough credits to unlock this profile. Please upgrade your subscription plan":"Sinulla ei ole tarpeeksi krediittejä tämän profiilin avaamiseen. Päivitä tilaussuunnitelmasi",
      "Category add successfully":"Ammatin lisäys onnistui",
      "Please upload file having extensions .jpeg/.jpg/.png only.":"Lähetä tiedosto, jonka tunniste on vain .jpeg/.jpg/.png",
      "Please enter a password with at least 8 characters, including uppercase, lowercase, digits, and any special characters(@$!%*#?&)":"Anna salasana, jossa on vähintään 8 merkkiä, mukaan lukien isot, pienet kirjaimet, numerot ja mahdolliset erikoismerkit (@$!%*#?&)"
    }
  },
  "es": {
    "language": "Estonian",
    "tab": {
      "Recent jobs":"Viimased töökohad",
      "Home": "Kodu",
      "Explore Jobs": "Töökohtade uurimine",
      "My Vacancies": "Minu vabat töökohad",
      "Post": "Postita",
      "Unlocked Profiles": "Avatud profiil",
      "My Profile": "Minu profiil"
    },
    "Home": {
      "Candidate near me":"Kandidaat minu läheduses",
      "Hey, There": "Tere seal",
      "Hey,": "Hei,",
      "Credits": "Krediidid",
      "Search by Candidates/categories/Services": "Otsige kandidaadi / tööstuse / teenuse järgi",
      "Job Categories": "Ametinimetus",
      "Show More": "Näita rohkem",
      "Show Less": "Näita vähem",
      "Your Subscription Info": "Teie tellimusteave",
      "Upgrade your subscription to fulfil your requirements with our best plans.": "Täiendage oma tellimust, et täita oma nõuded meie parimate plaanidega.",
      "Upgrade your Subscription": "Täiendage oma tellimust",
      "0 %": "0 %",
      "Complete Your Profile": "Täida oma profiil",
      "Your profile is incomplete! Please complete your profile to find the right candidate for your job": "Teie profiil on puudulik! Palun täitke oma profiil, et leida õige kandidaat oma tööle.",
      "Login Now": "Logige kohe sisse",
      "Complete Now": "Täida kohe",
      "Unlocked Profiles": "lukitsematon profiili",
      "All Profiles": "Kõik profiilid",
      "Candidates Near Me": "Kandidaadid minu lähedal",
      "View All": "Vaata kõiki",
      "Recommended Candidates": "Soovitatud kandidaadid",
      "Add to a List": "Lisa nimekirja",
      "Create New List": "Loo uus nimekiri",
      "Add": "Lisa",
      "Select Round": "Vali ring",
      "Use my Current Location": "Kasuta minu praegust asukohta",
      "Recent Locations": "Viimased asukohad",
      "Within 5 KM Radius": "5 km:n säteellä",
      "Within 10 KM Radius": "10 km:n säteellä",
      "Within 50 KM radius": "50 km:n säteellä",
      "Within 100 KM Radius": "100 km:n säteellä",
      "No New Notification Found": "Uut teavitust ei leitud."
    },
    "BlackCard": {
      "Premium": "Premium",
      "Verified": "Kinnitatud",
      "About Me": "Minust",
      "Experience": "Kogemus",
      "Experience Required": "Nõutav kogemus",
      "Employment Type": "Töölepingu tüüp",
      "Available": "Saadaval",
      "Expected Salary": "Oodatud palk",
      "Skills": "Oskused",
      "Education": "Haridus",
      "Passout Year": "Lõpetamise aasta",
      "Licenses": "Litsentsid",
      "Contact Details Locked": "Kontaktandmed on lukus",
      "See Full Details": "Vaata täielikku üksikasju",
      "Less Than 1 KM Away": "Vähem kui 1 km kaugusel",
      "KM Away": "KM kaugusel",
      "Availability for Part Time ": "Saadavus osalise tööajaga ",
      "You": "Sina",
      "Match": "Sobituma",
      "Add To A List": "Lisa nimekirja",
      "Create New List": "Loo uus nimekiri",
      "Select Vacancy": "Vali vaba ametikoht",
      "Add": "Lisa",
      "Select Round": "Vali voor",
      "Hire": "Värbama",
      "Please unlock the profile first": "Palun avage profiil kõigepealt",
      "Please do Login/Sign up": "Palun logige sisse/registreeruge",
      "Are you sure to unlock the profile": "Kas olete kindel, et soovite profiili avada?",
      "Write your lists": "Kirjutage oma nimekirjad"
    },
    "JobCategoriesdata": {
      "Candidate": "Kandidaat",
      "Candidates": "Kandidaadid"
    },
    "RecommendedComp": {
      "Verified": "Kinnitatud",
      "Available": "Saadaval",
      "Total Experience": "Kogemus kokku",
      "Year": "Aasta",
      "Years": "Aastad",
      "Current Location": "Praegune asukoht",
      "Miles Away": "Miili kaugusel",
      "Package": "Pakett",
      "Match": "Sobivus",
      "% Match": "% sobivus",
      "Last seen": "Viimati nähtud",
      "ago": "tagasi",
      "KM Away": "KM kaugusel"
    },
    "UnlockedProfileComp": {
      "KM": "KM",
      "Match": "Sobivus",
      "Unlocked on": "Lukustatud",
      "Total Experience": "Kogemus kokku",
      "Current Location": "Praegune asukoht"
    },
    "Message": {
      "Filters": "Filtrid",
      "Search by Candidates/Keyword": "Otsi kandidaatide/keywordi järgi",
      "Messages": "Sõnumid",
      "No Messages Found": "Sõnumeid ei leitud",
      "You": "Sina",
      "jobseeker":"Tööotsija",
      "Today":"Täna"
    },
    "SearchEvents": {
      "Subscription Details": "Tellimuse üksikasjad",
      "Looking for": "Otsin",
      "Select Required Skills": "Valige nõutavad oskused",
      "Employment Type": "Töölepingu tüüp",
      "Part Time": "Osaline tööaeg",
      "Full Time": "Täistööaeg",
      "Contract": "Leping",
      "Gender": "Sugu",
      "Male": "Mees",
      "Female": "Naine",
      "Experience": "Kogemus",
      "Years": "Aastad",
      "Maximum Distance": "Maksimaalne kaugus",
      "Km": "Km",
      "Age": "Vanus",
      "Salary": "Palk",
      "K": "K",
      "Candidate Type": "Kandidaadi tüüp",
      "Frees": "Tasuta",
      "Verified": "Kinnitatud",
      "Premium": "Premium",
      "Search Now": "Otsi nüüd",
      "Add To A List": "Lisa nimekirja",
      "Create New List": "Loo uus nimekiri",
      "Select Vacancy": "Valige vakants",
      "Free": "Tasuta",
      "Current Plan": "Praegune plaan",
      "VIP": "VIP"
    },
    "UnlockedPro": {
      "Available": "Saadaval",
      "Unlocked Profiles": "Lukustamata profiilid",
      "Search by Candidate Name": "Otsi kandidaadi nime järgi",
      "Filters": "Filtrid",
      "Verified": "Kinnitatud",
      "Available 20 Hrs/week": "Saadaval 20 tundi/nädalas",
      "Total Experience": "Kogemus kokku",
      "Years": "Aastad",
      "Current Location": "Praegune asukoht",
      "km": "km",
      "Package": "Pakett",
      "Match": "Sobitamine",
      "Unlocked on": "Lukustamata",
      "Add to a List": "Lisa nimekirja",
      "Create New List": "Loo uus nimekiri",
      "No Data Found": "Andmeid ei leitud"
    },
    "CreditHistory": {
      "Per Credit Amount":"Krediidisumma kohta",
      "Enter No. Credits":"Sisestage Krediidi number",
      "Total Amount":"Kogu summa",
      "Credit balance": "Krediidi saldo",
      "Available Credits": "Saadaval olevad krediidid",
      "Used Credits": "Kasutatud krediidid",
      "Total Credits": "Kokku krediidid",
      "Subscription Details": "Tellimuse üksikasjad",
      "Plan": "Plaan",
      "Days Left": "Päevi jäänud",
      "days Validity": "päeva kehtivus",
      "Purchased Date": "Ostukuupäev",
      "Validity": "Kehtivus",
      "days": "päeva",
      "Amount": "Summa",
      "Payment Mode": "Makseviis",
      "Credit History": "Krediidiajalugu",
      "Recharge Credit": "Laadi krediiti uuesti",
      "Select no. of Credits": "Vali krediitide arv",
      "Credits": "Krediidi",
      "Pay € 30": "Maksa € 30",
      "Premium": "Erisoodustus",
      "Credit Balance & History": "Krediidisaldo ja ajalugu",
      "Upgrade Plan": "Täiendusplaan",
      "Credit Top-up": "Krediidi täiendus",
      "Unlocked By": "Unlocked By",
      "End Date":"Lõppkuupäev"
    },
    "PaymentSuccesfull": {
      "Thank you !": "Aitäh !",
      "Your Payment was Successfull": "Teie makse oli edukas",
      "Your Transcation ID: 1236589742 & Your plan Renews on 15/04/2021": "Teie tehingu ID: 1236589742 ja Teie plaani uuendatakse 15.04.2021",
      "Post Vacancy": "Postita ametikoht",
      "Explore Candidates": "Uurige kandidaate"
    },
    "Subscription": {
      "Free": "Tasuta",
      "Vip": "VIP",
      "Premium": "Erisoodustus",
      "Current Plan": "Praegune plaan",
      "€ 300/pm": "€ 300/kuu",
      "Upgrade to": "Uuendage",
      "€ 499/pm": "€ 499/kuu",
      "Upgrade Now": "Uuenda kohe",
      "Credit": "Krediit",
      "Payment successful": "Makse edukas"
    },
    "RecommBlackCard": {
      "month subscription":"kuu tellimus",
      "Select Vacancy": "Vali vakants",
      "Add to a List": "Lisa nimekirja",
      "Create New List": "Loo uus nimekiri",
      "Add": "Lisa",
      "Select Round": "Vali ring",
      "10 %": "10 %",
      "%": "%",
      "Match": "Sobib",
      "Hire": "Värbama"
    },
    "Hiring": {
      "Select Vacancy": "Vali vakants",
      "Hiring Details": "Värbamise üksikasjad",
      "Vacancy Details": "Vakantsi üksikasjad",
      "Job Duration": "Töö kestus",
      "Submit": "Esita",
      "Add to a List": "Lisa nimekirja",
      "Create New List": "Loo uus nimekiri",
      "Add": "Lisa"
    },
    "UnlockedProfileBlackScreen": {
      "Add to a List": "Lisa nimekirja",
      "Create New List": "Loo uus nimekiri",
      "Add": "Lisa",
      "Done": "Valmis",
      "Select Round": "Vali ring",
      "Match": "Sobib",
      "Hire": "Värbama"
    },
    "CandidateNearMapScreen": {
      "Less than 1 Miles away": "Vähem kui 1 miili kaugusel",
      "Miles away": "Miili kaugusel",
      "10% Match": "10% sobivus",
      "% Match": "% sobivus",
      "View Profile": "Vaata profiili",
      "10%": "10%",
      "%": "%"
    },
    "SearchScreen": {
      "Search by candidates title, industry Title":"Otsige kandidaadi tiitli, valdkonna nimetuse järgi",
      "Filters": "Filtrid",
      "Experience Between": "Kogemus vahemikus",
      "Year": "Aasta",
      "Within": "Raadius",
      " mi of Radius": " mi raadiuses",
      "Salary Between": "Palk vahemikus",
      "K": "K",
      "No Data Found": "Andmed puuduvad",
      "Select Vacancy ": "Vali vabade ametikohtade hulgast",
      "Select Round": "Vali ring",
      "Add to a List": "Lisa nimekirja",
      "Create New List": "Loo uus nimekiri",
      "Add": "Lisa",
      "10 % Add": "10 % Lisa",
      "%": "%",
      "Match": "Vasta",
      "Hire": "Palga"
    },
    "EditProfile": {
      "Upload image": "Lae pilt üles",
      "Personal Information": "Isiklik informatsioon",
      "Submit": "Kinnita"
    },
    "HireDetails": {
      "Post Settings":"Töökuulutuse seated",
      "Hires": "Palgatöötajad",
      "Time Sheet": "Ajakava",
      "View Full Profile": "Vaata täielikku profiili",
      "OnGoing Job": "Hetkel tööl",
      "Hours Worked": "Töötatud tundide arv",
      "Hours": "Tundi",
      "Job Duration": "Töö kestus",
      "Hired Date": "Palgatud kuupäev",
      "Verified": "Kinnitatud",
      "All times are in your local your local (PTS)": "Kõik ajad on sinu ajavööndis (PTS)"
    },
    "SuccessfulHire": {
      "Your Hire Request to ramesh has been sent Successfully": "Teie palga taotlus ramesh'ile on edukalt saadetud",
      "Resume Hiring": "Jätka palgamist"
    },
    "ApplicantsDetails": {
      "Filters": "Filtrid:",
      "Availability for Part Time": "Olemasolu osalise tööajaga",
      "99% ": "99% ",
      "match": "Vasta",
      "Hire": "Palga"
    },
    "NoDataFound": {
      "Opps ! ": "Vabandust ! ",
      "No Data Found ": "Andmeid ei leitud ",
      "Post New Vacancy": "Postita uus töökuulutus"
    },
    "PostNewVacancy": {
      "Enter Address":"Sisesta aadress",
      "Confirm to Reject": "Kinnita tagasilükkamine",
      "Confirm to Accept": "Kinnita vastuvõtmine",
      "Select Required Skills": "Vali nõutavad oskused",
      "Job Description": "Töö kirjeldus",
      "Select Required Experience": "Vali nõutav kogemus",
      "No Of Vacancies": "Vabade töökohtade arv",
      "Job Duration(In Days)": "Töö kestvus (päevades)",
      "Enter Compensation Amount": "Sisesta kompensatsiooni summa",
      "Post Vacancy": "Saada töökuulutus",
      "Enter Job Title": "Sisesta ametinimetus",
      "Company Name (Please Update Your Profile)": "Firma nimi (Palun uuenda oma profiili)",
      "Select Job Category": "Vali Elukutse tüüp",
      "Job Details": "Töö detailid",
      "Is this vacancy Urgent ? ": "Kas see töökoht on kiireloomuline?",
      "Is Liscense Requrired ?": "Kas on vajalik litsents?",
      "Employment Details": "töölepingu tüüp",
      "Compensation Details": "Kompensatsiooni detailid",
      "Company Details": "Firma detailid",
      "Work Location": "Töö asukoht",
      "Contact Person Name": "Kontaktisiku nimi",
      "Contact Number": "Kontakti number",
      "Select Highest Degree": "Vali kõrgeim kraad",
      "Highest Degree Completion Year": "Kõrgeima kraadi lõpetamise aasta",
      "Maximum Application Required": "Maksimaalne töötaotluste arv",
      "Enter Search Radius (In Meters)": "Sisesta otsingu raadius (Kilomeetris)",
      "Enter Short Description": "Sisesta lühikirjeldus",
      "Qualification Required ": "Nõutavad kvalifikatsioonid",
      "Post Setting": "Postituse seaded",
      "Review & Post Vacancy": "Vaata üle ja postita töökuulutus"
    },
    "PostSuccessFulMessage": {
      "Edit Vacancy": "Muuda töökuulutust",
      "Post SuccessFul": "Töökuulutuse postitamine õnnestus",
      "Vacancy Posted Successfully !": "Töökuulutus postitatud edukalt !",
      "Post Another Vacancy": "Postita veel üks töökuulutus"
    },
    "MyProfile": {
      "Update Now":"Värskenda",
      "Update":"Värskenda",
      "Welcome to Catzapp": "Tere tulemast Catzappi",
      "Login": "Logi sisse",
      "Log Out": "Logi välja",
      "My Profile": "Minu profiil",
      "Create an Account": "Loo konto",
      "My Subscriptions": "Minu tellimused",
      "My Lists": "Minu nimekirjad",
      "My Vacancies": "Minu tööpakkumised",
      "My Unlocked Candidates": "Minu lahtilukustatud kandidaadid",
      "Sub Users": "Alluvkasutajad",
      "Settings": "Seaded",
      "Language": "Keel",
      "Alert/Notifications": "Teatised/Mittekohalolek",
      "Privacy & Policies": "Privaatsus ja poliitika",
      "Contact Support": "Kontakteeru toeosakonnaga",
      "Update Profile": "Uuenda profiili",
      "Upload Image": "Lae pilt üles",
      "Personal Information": "Isiklik teave",
      "Submit": "Esita",
      "Upolad Your Company Image": "Laadi oma ettevõtte pilt üles",
      "About Your Company": "Sinu ettevõttest",
      "Company Location": "Ettevõtte asukoht",
      "Company Website": "Ettevõtte veebisait",
      "Company Name": "Ettevõtte nimi",
      "Add Your Company": "Lisa oma ettevõte",
      "Select Company": "Vali ettevõte",
      "Email": "E-post",
      "Last Name": "Perekonnanimi",
      "First Name": "Eesnimi",
      "My List Screen": "Minu nimekirja ekraan",
      "Remove": "Eemalda",
      "Select Language": "Vali keel"
    },
    "NoUserFound": {
      "Opps !": "Vabandust!",
      "No Sub User Found": "Alluvkasutajaid ei leitud",
      "Create Sub User": "Loo alluvkasutaja"
    },
    "NewSubUser": {
      "User Details": "Kasutaja andmed",
      "Enter User Name": "Sisesta kasutajanimi",
      "Enter First Name": "Sisesta eesnimi",
      "Enter Last Name": "Sisesta perekonnanimi",
      "Enter Email Address": "Sisesta e-posti aadress",
      "Enter Mobile Number": "Sisesta mobiilinumber",
      "Enter Password": "Sisesta parool",
      "Confirm Password": "Kinnita parool",
      "Update Sub User ": "Uuenda alamkasutajat",
      "Create Sub User ": "Loo alamkasutaja",
      "Enter Full Name": "Sisesta täisnimi"
    },
    "MyList": {
      "No Data Found": "Andmeid ei leitud",
      "Remove": "Eemalda",
      "Available": "Saadaval"
    },
    "Settings": {
      "Email Notification": "E-kirja teavitused",
      "Notification": "Teavitused",
      "Update Password": "Uuenda parool"
    },
    "PrivacyPolicies": {
      "PRIVACY POLICY": "PRIVAATSUSPOLIITIKA",
      "Welcome to Recruiter": "Tere tulemast värbajasse",
      "1. Introduction": "1. Sissejuhatus",
      "2. Definitions": "2. Määratlused",
      "3. Information Collection and Use": "3. Teabe kogumine ja kasutamine",
      "4. Types of Data Collected ": "4. Kogutud andmete tüübid ",
      "5. Types of Data Collected": "5. Kogutud andmete tüübid"
    },
    "ContactSupport": {
      "Submit": "Saada"
    },
    "MyListsScreen": {
      "Salery- Compensation":"Palk – Tasu",
      "Required": "Nõutud",
      "Immediately": "Kohe",
      "Total Experience": "Kogemus",
      "Years": "Aastad",
      "Year": "Aasta",
      "Work Location": "Töökoha asukoht",
      "Package": "Pakett"
    },
    "PlayListBlackCard": {
      "Select Vacancy": "Vali vabade töökohtade hulgast",
      "Select Round": "Vali voor",
      "Add to a List ": "Lisa loendisse",
      "Create New List ": "Loo uus loend",
      "Add": "Lisa",
      "Done": "Valmis",
      "Match": "Sobita",
      "Add Your List": "Lisa oma loend"
    },
    "SignUp": {
      "Enter Your Name": "Sisesta oma nimi",
      "Enter Your Phone Number": "Sisesta oma telefoninumber",
      "Enter Your Email": "Sisesta oma e-posti aadress",
      "Enter Password": "Sisesta parool",
      "Set a password": "Määra parool",
      "Confirm password ": "Kinnita parool",
      "Confirm": "Kinnita"
    },
    "LoginPassword": {
      "Login": "Logi sisse",
      "Forgot Password": "Unustasid parooli?",
      "Don't have an account?": "Kas sul pole kontot?",
      "SignUp": "Registreeri",
      "SKIP": "JÄTA VAHELE",
      "Please Enter MobileNumber & Password": "Sisesta oma telefoni number ja parool",
      "Please Enter Your Mobile Number": "Sisesta oma telefoni number",
      "Please Enter Your Password": "Sisesta oma parool",
      "Please Enter Valid Password": "Sisesta kehtiv parool",
      "Please enter your mobile number to complete the login process.": "Palun sisesta oma telefoni number, et logimine lõpule viia.",
      "Enter Your Mobile Number": "Sisesta oma telefoni number",
      "Enter Your Password": "Sisesta oma parool",
      "Login to Catzapp Recruiter": "Kirjaudu Catzapp Recruiteriin",
      "OTP": "OTP"
    },
    "ChangePassword": {
      "Please Enter Your New Password & Confirm Password": "Sisestage uus parool ja kinnitage see",
      "Please Enter Your New Password": "Sisestage oma uus parool",
      "Please Enter Valid password": "Sisestage sobiv parool",
      "Please Enter Confirm Password": "Sisestage kinnitatud parool",
      "Password dosen't Match": "Paroolid ei ühti",
      "Reset Your Password": "Lähtesta oma parool",
      "Set a password": "Määrake parool",
      "Confirm password": "Kinnitage parool",
      "Enter Your New password": "Sisestage oma uus parool",
      "Confirm Your New password": "Kinnitage oma uus parool"
    },
    "ResetPassword": {
      "Please Enter Mobile Number": "Sisestage oma mobiilinumber",
      "Submit OTP": "Esitage OTP",
      "Please Enter Otp": "Sisestage OTP",
      "We Have sent One Time Password to": "Me oleme saatnud ühekordse parooli aadressile"
    },
    "interOtp": {
      "we have sent an OTP to": "Me oleme saatnud OTP aadressile",
      "Did Not Receive Code Yet?": "Pole veel koodi saanud?",
      "Resend OTP": "Saada OTP uuesti",
      "Please Enter OTP": "Sisestage OTP",
      "Submit": "Esita"
    },
    "forgetPassword": {
      "Send OTP": "Saada OTP",
      "Get Password": "Hangi parool",
      "Enter Mobile Number": "Sisestage mobiilinumber",
      "Please enter your mobile number to generate OTP": "Palun sisestage oma mobiilinumber, et genereerida OTP",
      "Please Enter Your Mobile Number": "Sisestage oma mobiilinumber"
    },
    "myVacancy": {
      "Search by Job Title": "Otsi ametikoha järgi",
      "My Vacancies": "Minu töökohad",
      "No Data Found": "Andmeid ei leitud",
      "Applications": "Taotlused",
      "Application": "Taotlus",
      "Edit": "Muuda",
      "Delete": "Kustuta",
      "Required": "Nõutav",
      "Immediately": "Kohe",
      "Posted": "Avaldatud",
      "ago": "tagasi",
      "Applicants": "Kandidaadid",
      "Hire": "Palgata",
      "Apply Filters": "Rakenda filtreid",
      "Clear All": "Kustuta kõik",
      "Make Admin":"Muuda administraatoriks"
    },
    "new": {
      "No Required Immediately":"Ei nõuta kohe",
      "Please Select date range":"Palun valige kuupäevavahemik",
      "About Company": "Ettevõtte kohta",
      "Latter": "Viimane",
      "All": "Kõik",
      "Not Premium": "Pole premium",
      "Premium": "Premium",
      "Buy Credit to Unlock the Candidates and Proceed further with the process to send messages, chat or call.": "Ostu krediidi kandidaatide avamiseks ja vestluse, sõnumi või kõne protsessi jätkamiseks.",
      "Are you sure you want to delete this chat?": "Kas olete kindel, et soovite selle vestluse kustutada?",
      "Recommended Profiles": "Soovitatud profiilid",
      "Map View": "Kaardi vaade",
      "List View": "Loendi vaade",
      "Read": "Lugeda",
      "2 Credits will get deducted. Are you sure to unlock the profile?": "2 krediiti arvatakse maha. Kas olete kindel, et soovite profiili avada?",
      "Subscribe Now": "Telli kohe",
      "Please unlock profile first": "Palun avage profiil kõigepealt",
      "You do not have a login yet, Please do login/Signup to continue.": "Teil pole veel sisse logitud, jätkamiseks logige sisse / registreeruge.",
      "Signup/Login": "Registreeru/Sisselogimine",
      "Welcome to Catzapp": "Tere tulemast Catzappi",
      "Create Account": "Konto loomine",
      "Or": "Või",
      "Sign In": "Logi sisse",
      "Skip": "Jäta vahele",
      "Yes": "Jah",
      "No": "Ei",
      "Part Time": "Osaline tööaeg",
      "Full Time": "Täistööaeg",
      "Contract": "Lepingu alusel",
      "Daily": "Päevane",
      "Weekly": "Nädalane",
      "Monthly": "Kuu põhine",
      "Yearly": "Aastane",
      "Please Enter Category Name":"Palun sisestage kategooria nimi",
      "Upload Category Image": "Laadige üles elukutse pilt",
      "From Date": "Alates kuupäevast",
      "To Date": "Kuupäevani",
      "Selected": "Valitud",
      "Rejected": "Tagasi lükatud",
      "First Round": "Esimene voor",
      "Second Round": "Teine ring",
      "Type Message": "Kirjuta sõnum",
      "Subject": "Teema",
      "Enter your Description": "Sisestage oma kirjeldus",
      "Please Unlock Profile First": "Palun avage profiil kõigepealt",
      "Please Select Vacancy": "Palun valige vakants",
      "Please Select From Date": "Palun valige alates kuupäevast",
      "Please Select To Date": "Palun valige kuupäevani",
      "Please Enter Details": "Palun sisestage üksikasjad",
      "Please Enter valid Email": "Palun sisestage kehtiv e-posti aadress",
      "Passwords should be a minimum of eight characters in length": "Paroolid peaksid olema vähemalt kaheksa tähemärki pikkused",
      "Please Confirm Your Password": "Palun kinnitage oma parool",
      "Password Does Not Match": "Paroolid ei kattu"
    },
    "FinalFinal": {
      "You have created a hire request": "Olete loonud renditaotluse",
      "Hire request already exists": "Renditaotlus on juba olemas",
      "Please Upload Image to add new categories": "Uute kategooriate lisamiseks laadige üles Elukutse",
      "Want to post vacancy please upgrade subscrption": "Kui soovite avaldada vaba töökohta, uuendage tellimust",
      "Please enter number of vacancy": "Palun sisesta vabade töökohtade arv",
      "Please enter search radius": "Palun sisesta otsingu raadius",
      "Enter Your Email Address": "Sisestage oma e-posti aadress",
      "Enter Your Phone Number": "Sisestage oma telefoninumber",
      "Please Enter Title": "Palun sisestage pealkiri",
      "Please Enter Description": "Palun sisestage kirjeldus",
      "Enter Your First Name": "Sisestage oma eesnimi",
      "Enter Your Last Name": "Sisestage oma perekonnanimi",
      "Password must be minimum of 8 character": "Salasõna peab olema vähemalt 8 tähemärki pikk",
      "Enter Confirm Password": "Sisestage salasõna uuesti",
      "Enter Valid Password (password must be combination of letters, numbers and special character": "Sisestage kehtiv salasõna (salasõna peab olema tähtede, numbrite ja erimärkide kombinatsioon)",
      "Please Enter First Name": "Palun sisestage eesnimi",
      "Please Enter Last Name": "Palun sisestage perekonnanimi",
      "Please Enter Email": "Palun sisestage e-posti aadress",
      "Please Select or Add a Company": "Palun valige või lisage ettevõte",
      "Please Select Profile Picture": "Palun valige profiilipilt",
      "Please enter Job Title": "Palun sisestage ametinimetus",
      "Please select Company": "Palun valige ettevõte",
      "Please Select Company Image": "Palun valige ettevõtte pilt",
      "Please Enter Company Detail": "Palun sisestage ettevõtte detailid",
      "Please select Job Category": "Palun valige elukutse tüüp",
      "Please select required Experience": "Palun valige nõutav kogemus",
      "Please enter Job Description": "Palun sisestage töö kirjeldus",
      "Please enter short description": "Palun sisestage lühike kirjeldus",
      "Please select Skills": "Palun valige oskused",
      "Please select urgent vacancy": "Palun valige kiireloomuline töökoht",
      "Please select liscense required": "Palun valige nõutav litsents",
      "Please select to date": "Palun valige kuupäev",
      "Please select from date": "Palun valige kuupäevast",
      "Please enter maximum number of application": "Palun sisestage maksimaalne taotluste arv",
      "Please select category image": "Valige kutsekujutis",
      "Please select Highest Degree": "Palun valige kõrgeim kraad",
      "Please enter contact person number": "Palun sisestage kontaktisiku telefoninumber",
      "Please enter contact person name": "Palun sisestage kontaktisiku nimi",
      "Please enter Job Location": "Palun sisestage töökoht",
      "Please enter Compensation Amount": "Palun sisestage hüvitise summa",
      "Please enter Compensation Details": "Palun sisestage hüvitise detailid",
      "Please enter Job Duration": "Palun sisestage töö kestus",
      "Please select employment details": "Palun töölepingu tüüp",

      ".png Images are not supported": ".png-pildid pole toetatud",
      "Please Enter Company Name": "Sisesta ettevõtte nimi",
      "Please Enter Company Website": "Sisesta ettevõtte veebisait",
      "OK": "OK"
    },
    "LastL": {
      "Stored Messages": "Salvestatud sõnumid",
      "Unlocked By": "Avatud",
      "User Type": "Kasutajatüüp",
      "Search": "Otsi",
      "Filter By": "Filtreeri",
      "Sort By": "Sorteeri",
      "Experience": "Kogemus",
      "Location Radius": "Asukoha raadius",
      "Matching Percentage": "Vastavusprotsent",
      "Package Range": "Paketi vahemik",
      "Passout Year": "Lõpetamise aasta",
      "Distance": "Kaugus",
      "Search by Area/Street/City Name": "Otsi piirkonna/tänava/linna nime järgi",
      "Please select Highest Degree completion year": "Valige kõrgeima kraadi lõpetamise aasta"
    },
    "Lastest": {
      "NoAccount": "Konto puudub?",
      "Login": "Logi sisse",
      "Sec": "Sek.",
      "Please Wait": "Palun oodake",
      "UpGradePlan": "Kandidaadi profiili vaatamiseks palun uuendage on plaan",
      "Monthly": "Igakuine",
      "ProfileUpdate": "Profiili uuendamine õnnestus",
      "NewCategory": "Lisa uus elukutse tüüp",
      "Submit": "Kinnita",
      "Unlocked": "Avatud",
      "First Round": "Esimene voor",
      "Second Round": "Teine voor",
      "Selected": "Valitud",
      "Rejected": "Tagasilükatud",
      "CandidateAlreadyExist": "Kandidaat on juba lisatud valitud loendisse",
      "Monday": "esmaspäev",
      "Tuesday": "teisipäeval",
      "Wednesday": "kolmapäeval",
      "Thursday": "neljapäeval",
      "Friday": "reedel",
      "Saturday": "laupäeval",
      "Sunday": "pühapäev",
      "LanguageAlert": "Palun sulgege rakendus ja taaskäivitage see teise rakenduse valimiseks",
      "Hire": "Töölevõtt",
      "Hirerequest": "Olete loonud töölevõtu taotluse",
      "DeleteJob": "Kas olete kindel, et soovite eemaldada selle töö?",
      "Address": "Aadress",
      "Jobs": "Töökohad",
      "Login Successfully": "Sisselogimine õnnestus",
      "Hours": "Tunnid",
      "Premium": "Premium",
      "Minutes": "Minutid",
      "Invalid credentials": "Kehtetud mandaadid",
      "Status : Accepted": "Staatus: Vastu võetud",
      "Status : Rejected": "Staatus: Tagasi lükatud",
      "Unread": "Lugemata"
    },
    "Newtranslation": {
      "FREE":"TASUTA",
      "My Subcription":"Minu tellimus",
      "job": "Vaata töökohti",
      "HireRequest": "Vaata töölevõtu taotlust",
      "Timesheet": "Vaata ajatabelit",
      "Message": "Vaata sõnumit",
      "Unlocked by recruiter": "Vaata v'rbaja poolt avatuid",
      "Monthly Plan": "Kuuplaan",
      "Half Yearly Plan": "Poolaasta plaan",
      "Yearly Plan": "Aastaplaan",
      "valid for ": "kehtib ",
      "days": "päeva",
      "Feature": "Omadus",
      "Includescredits": "Sisaldab 10 krediiti kuus.",
      "Credits can be carried forward each month": "Krediite saab iga kuu edasi kanda",
      "Upgrade Subcription": "Tellimuse täiendamine",
      "Newcandidate": "Teie autojuhi ametikohale kandideeris uus kandidaat. kontrollige kohe",
      "No relevant candidate found": "Ühtegi sobivat kandidaati ei leitud",
      "Years of": "Aastaid",
      "Candidates": "Kandidaadid",
      "The payment has been canceled": "Makse on tühistatud",
      "Applicant already exist": "Taotleja on juba olemas",
      "The payment method was setup successfully": "Makseviisi seadistamine õnnestus",
      "Your Hire Request has been sent successfully": "Teie töölevõtu taotlus on edukalt saadetud",
      "Slot Available": "Slot saadaval",
      "Task Description": "Ülesande kirjeldus",
      "Time Sheet Approved successfully": "Ajatabel edukalt kinnitatud",
      "Time Sheet disapproved": "Ajatabeli tagasilükkamine õnnestus",
      "Search By Candidate title": "Otsi kandidaati ameti järgi",
      "This phone number doesn't exist": "Seda telefoninumbrit ei eksisteeri",
      "OTP send successfully": "Ühekorde salasõna saatmine õnnestus",
      "Login Successfully": "Sisselogimine õnnestus",
      "Invalid Credentials": "Kehtetu kasutajatunnus/salasõna",
      "Enter Current Password": "Sisesta kehtiv salasõna",
      "Enter New Password": "Sisesta uus salasõna",
      "Confirm New Password": "Kinnita uus salasõna",
      "Cancel": "Katkesta",
      "You cannot set the old password again.":"Vana parooli ei saa määrata"
    },
    "YearMonth": {
      "Enter Valid Mobile Number":"Sisestage kehtiv mobiilinumber",
      "Select payment period above and enter salary in the field below":"Vali palga maksmise periood ja sisesta palk allolevale väljale",
      "This Company already exist":"See ettevõte on juba olemas",
      "View All Vacancy":"Kuva kõik vabad töökohad",
      "Enter Company Website":"Sisesta ettevõtte veebisait",
      "Enter About Your Company":"Sisesta oma ettevõtte kohta",
      "My Vacancy":"Minu vaba koht",
      "Please verify your account":"Palun kinnitage oma konto",
      "Username":"Kasutajanimi",
      "Password":"Parool",
      "Vacancies":"Vabad töökohad",
      "Please Enter Credit Point":"Palun sisestage krediidipunkt",
      "Not Availability for Part Time":"Pole saadaval osalise tööajaga",
      "You didn't add any new skill.":"sa ei lisanud uusi oskusi",
      "New skill addded":"Lisatud uus oskus",
      "Degree add successfully":"Kraadi lisamine õnnestus",
      "Add New Degree":"Lisa uus kraad",
      "Degree":"kraad",
      "You didn't add any new Degree":"Te ei lisanud ühtegi uut kraadi",
      "New Password and Confirm Password does not match":"Uus parool ja parooli kinnitamine ei ühti",
      "passwordValidation":"Parool peab olema tähtnumbriline.Parooli esimene täht peab olema suur.Parool peab sisaldama erimärki (@, $, !, & jne).Parool peab olema pikem kui 8 tähemärki.",
      "You want to delete this Vaccancy?":"Kas soovite selle vakantsi kustutada?",
      "You created a playlist successfully":"Lõite esitusloendi edukalt",
      "Your Playlist Title":"Teie esitusloendi pealkiri",
      "previous":"eelmine",
      "Next":"Edasi",
      "Post Another Vacancy":"Avalda veel üks vaba töökoht",
      "Password Reset":"Password Reset",
      "password and confirm password doesnot match":"parool ja kinnitage, et parool ei ühti",
      "Confirm Password Required":"Kinnitage parool Nõutav",
      "Password Required":"Nõutav parool",
      "New Company added sucessfully!":"Uusi yritys lisätty onnistuneesti!",
      "Profile Image":"Profiilipilt",
      "Invalid OTP":"Vale OTP",
      "Register successfully":"Registreerumine õnnestus",
      "Notification Got Deleted Successfully":"Märguanne on edukalt kustutatud",
      "January": "tammikuu",
      "February": "helmikuu",
      "March": "maaliskuuta",
      "April": "huhtikuu",
      "May": "saattaa",
      "June": "kesäkuuta",
      "July": "heinäkuu",
      "August": "august",
      "September": "syyskuu",
      "October": "lokakuu",
      "November": "marraskuu",
      "December": "joulukuu", 
      "Today": "Täna",
      "Yesterday": "eile",
      "a minute ago": "minut tagasi",
      "minutes ago": "minutit tagasi",
      "hours ago": "tundi tagasi",
      "a hour ago": "tund tagasi",
      "a day ago": "päev tagasi",
      "days ago": "päeva tagasi",
      "Do You Really Want To Delete Your Account":"Kas oled kindel, et soovid konto kustutada?",
      "phone, username already exist":"telefon, kasutajanimi on juba olemas",
      "User does not exists":"Kasutajat pole olemas",
      "This phone number doesn't exist":"Seda telefoninumbrit pole olemas",
      "Login Successfully":"Sisselogimine õnnestus",
      "User is deactivated by admin":"Administraator on kasutaja deaktiveerinud",
      "Time sheet downloaded successfully, Please check your download folder":"Ajaleht on edukalt alla laaditud. Kontrollige oma allalaadimiskausta",
      "Space are not allowed":"Ruumid ei ole lubatud",
      "Are you sure you want to Transfer Admin Right?":"Kas olete kindel, et soovite administraatoriõiguse teisaldada?",
      "Close":"Sulge",
      "certificate":"tunnistus",
      "already exist":"juba olemas",
      "phone, email, username already exist":"phone, email, username already exist",
      "Incorrect Authentication Credentials": "Kehtetu kasutajatunnus/salasõna",
      "Please correct the following errors.":"Parandage järgmised vead.",
      "phone, email already exist":"telefon, e-post on juba olemas",
      "email already exist":"e-post on juba olemas",
      "phone already exist":"telefon on juba olemas",
      "You have created a new sub user": "Olete loonud uue alamkasutaja",
      "You have updated a sub user's detail":"Olete värskendanud alamkasutaja andmeid",
      "Admin":"Admin",
      "Sub-User":"Alamkasutaja",
      "Created":"Loodud",
      "Year":"aasta",
      "OTP verified successfully Successfully":"OTP kinnitamine õnnestus",
      "OTP verified Successfully":"OTP kinnitamine õnnestus",
      "Login":"Logi sisse",
      "Please Enter Current Password":"Palun sisestage praegune parool",
      "Please Enter New Password":"Palun sisestage uus parool",
      "Password Does not Match":"Salasõna ei klapi",
      "You cannot set the old password again":"Te ei saa vana parooli uuesti määrata",
      "Password Reset":"Parooli lähtestamine",
      "Thank you for contacting our support team. We'll get back to you soon!":"Täname teid meie tugitiimi ühendamise eest. Võtame teiega varsti ühendust",
      "Password updated successfully":"Parooli värskendamine õnnestus",
      "Timesheet Approved Successfully":"Tööajatabel edukalt kinnitatud",
      "Timesheet Disapproved Successfully":"Tööajatabel lükati edukalt tagasi",
      "You do not have enough credits to unlock this profile. Please upgrade your subscription plan":"Teil pole selle profiili avamiseks piisavalt krediiti. Täiendage oma tellimuspaketti",
      "This field may not be blank.":"See väli ei tohi olla tühi.",
      "Are You Sure!":"Oled sa kindel!",
      "Category add successfully":"Elukutse lisamine õnnestus",
      "Please upload file having extensions .jpeg/.jpg/.png only.":"Palun laadige üles fail, mille laiendid on ainult .jpeg/.jpg/.png.",
      "Please enter a password with at least 8 characters, including uppercase, lowercase, digits, and any special characters(@$!%*#?&)":"Palun sisestage parool, mis koosneb vähemalt 8 tähemärgist, sealhulgas suur- ja väiketähed, numbrid ja kõik erimärgid (@$!%*#?&)"
    }
  }
}